// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/scss/fonts/atlasgrotesk-bold-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./assets/scss/fonts/atlasgrotesk-bold-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./assets/scss/fonts/atlasgrotesk-regular-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./assets/scss/fonts/atlasgrotesk-regular-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./assets/scss/fonts/futura-book-bt-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./assets/scss/fonts/futura-book-bt-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./assets/scss/fonts/futura-bt-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./assets/scss/fonts/futura-bt-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./assets/scss/fonts/NeueHaasGrotDispRound-55Roman-Web.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./assets/scss/fonts/NeueHaasGrotDispRound-55Roman-Web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./assets/scss/fonts/NeueHaasGrotTextRound-65Medium-Web.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./assets/scss/fonts/NeueHaasGrotTextRound-65Medium-Web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./assets/scss/fonts/NeueHaasGrotTextRound-55Roman-Web.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./assets/scss/fonts/NeueHaasGrotTextRound-55Roman-Web.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./assets/scss/fonts/NeuzeitSLTStd-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./assets/scss/fonts/NeuzeitSLTStd-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./assets/scss/fonts/NeuzeitSLTStd-bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./assets/scss/fonts/NeuzeitSLTStd-bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./assets/scss/fonts/nhaasgrotesktxpro-55rg-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./assets/scss/fonts/nhaasgrotesktxpro-55rg-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("./assets/scss/fonts/nhaasgrotesktxpro-65md-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("./assets/scss/fonts/nhaasgrotesktxpro-65md-webfont.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("./assets/scss/fonts/nhaasgrotesktxpro-75bd-webfont.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("./assets/scss/fonts/nhaasgrotesktxpro-75bd-webfont.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
        This font software is the property of Commercial Type.

        You may not modify the font software, use it on another website, or install it on a computer.

        License information is available at http://commercialtype.com/eula
        For more information please visit Commercial Type at http://commercialtype.com or email us at info[at]commercialtype.com

        Copyright (C) 2021 Schwartzco Inc.
        License: 2109-TPLXSX
*/
@font-face {
  font-family: "Atlas Grotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
  font-weight: 700;
  font-style: normal;
  font-stretch: normal;
}
@font-face {
  font-family: "Atlas Grotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
}
@font-face {
  font-family: "Futura";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
}
@font-face {
  font-family: "Futura";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
}
@font-face {
  font-family: "Haas Grot Disp R Web";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
}
.NeueHaasGrotDispRound-55Roman-Web {
  font-family: "Haas Grot Disp R Web";
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
}

@font-face {
  font-family: "Haas Grot Text R Web";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
}
.NeueHaasGrotTextRound-65Medium-Web {
  font-family: "Haas Grot Text R Web";
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
}

@font-face {
  font-family: "Haas Grot Text R Web";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
}
.NeueHaasGrotTextRound-55Roman-Web {
  font-family: "Haas Grot Text R Web";
  font-weight: 400;
  font-style: normal;
  font-stretch: normal;
}

@font-face {
  font-family: "Neuzeit S LT Std";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff2");
  font-weight: 400;
}
@font-face {
  font-family: "Neuzeit S LT Std";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff2");
  font-weight: 850;
}
@font-face {
  font-family: "Neue Haas Grotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff2");
  font-weight: 400;
}
@font-face {
  font-family: "Neue Haas Grotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("woff2");
  font-weight: 500;
}
@font-face {
  font-family: "Neue Haas Grotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("woff2");
  font-weight: 700;
}
/* Box sizing */
*,
*::before,
*::after {
  box-sizing: border-box;
}

/* Reset margins */
body,
h1,
h2,
h3,
h4,
h5,
p {
  margin: 0;
  letter-spacing: 0.01em;
}

/* set up the body */
body {
  line-height: 1.5;
  min-height: 100vh;
}

/* make images easier to work with */
img {
  max-width: 100%;
  display: block;
}

/* make form elements easier to work with */
input,
button,
textarea,
select {
  font: inherit;
}

/* remove animations for people who've turned them off */
@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    transition-duration: 0.01ms !important;
    scroll-behavior: auto !important;
  }
}
:root {
  --color-white: #ffffff;
  --color-black: #000000;
  --color-grey: #8f8f8f;
  --color-yellow: #fffb00;
  --color-red: red;
  --h1-fs: 50px;
  --h1-lh: 55px;
  --h2-fs: 38px;
  --h2-lh: 41px;
  --nav-fs: 19px;
  --nav-lh: 25px;
  --body-fs: 14px;
  --body-lh: 19px;
  --table-fs: 14px;
  --table-lh: 16px;
  --subtitle-fs: 14px;
  --subtitle-lh: 16px;
  --fw-light: 300;
  --fw-normal: 400;
  --fw-medium: 500;
  --fw-semibold: 600;
  --fw-bold: 700;
}

@media (max-width: 768px) {
  :root {
    --h1-fs: 40px;
    --h1-lh: 45px;
    --h2-fs: 30px;
    --h2-lh: 35px;
    --nav-fs: 19px;
    --nav-lh: 25px;
    --body-fs: 16px;
    --body-lh: 22px;
    --table-fs: 14px;
    --table-lh: 16px;
    --subtitle-fs: 12px;
    --subtitle-lh: 16px;
  }
}
:root {
  --color-white: #ffffff;
  --color-black: #000000;
  --color-grey: #8f8f8f;
  --color-yellow: #fffb00;
  --color-red: red;
  --h1-fs: 50px;
  --h1-lh: 55px;
  --h2-fs: 38px;
  --h2-lh: 41px;
  --nav-fs: 19px;
  --nav-lh: 25px;
  --body-fs: 14px;
  --body-lh: 19px;
  --table-fs: 14px;
  --table-lh: 16px;
  --subtitle-fs: 14px;
  --subtitle-lh: 16px;
  --fw-light: 300;
  --fw-normal: 400;
  --fw-medium: 500;
  --fw-semibold: 600;
  --fw-bold: 700;
}

@media (max-width: 768px) {
  :root {
    --h1-fs: 40px;
    --h1-lh: 45px;
    --h2-fs: 30px;
    --h2-lh: 35px;
    --nav-fs: 19px;
    --nav-lh: 25px;
    --body-fs: 16px;
    --body-lh: 22px;
    --table-fs: 14px;
    --table-lh: 16px;
    --subtitle-fs: 12px;
    --subtitle-lh: 16px;
  }
}
h1 {
  font-size: var(--h1-fs);
  line-height: var(--h1-lh);
}

h2 {
  font-size: var(--h2-fs);
  line-height: var(--h2-lh);
}

h3 {
  font-size: var(--body-fs);
  line-height: var(--body-lh);
}

h1,
h2,
h3 {
  font-weight: var(--fw-normal);
  color: var(--color-white);
}

p,
a {
  text-decoration: none;
  color: var(--color-white);
  font-weight: var(--fw-normal);
  font-size: var(--body-fs);
  line-height: var(--body-lh);
}

a {
  transition: all 0.3s linear;
}
a:hover {
  color: var(--color-yellow);
}

.App {
  background: black;
}
@media only screen and (max-width: 768px) {
  .App button.small {
    min-height: 148px;
  }
}
:root {
  --color-white: #ffffff;
  --color-black: #000000;
  --color-grey: #8f8f8f;
  --color-yellow: #fffb00;
  --color-red: red;
  --h1-fs: 50px;
  --h1-lh: 55px;
  --h2-fs: 38px;
  --h2-lh: 41px;
  --nav-fs: 19px;
  --nav-lh: 25px;
  --body-fs: 14px;
  --body-lh: 19px;
  --table-fs: 14px;
  --table-lh: 16px;
  --subtitle-fs: 14px;
  --subtitle-lh: 16px;
  --fw-light: 300;
  --fw-normal: 400;
  --fw-medium: 500;
  --fw-semibold: 600;
  --fw-bold: 700;
}

@media (max-width: 768px) {
  :root {
    --h1-fs: 40px;
    --h1-lh: 45px;
    --h2-fs: 30px;
    --h2-lh: 35px;
    --nav-fs: 19px;
    --nav-lh: 25px;
    --body-fs: 16px;
    --body-lh: 22px;
    --table-fs: 14px;
    --table-lh: 16px;
    --subtitle-fs: 12px;
    --subtitle-lh: 16px;
  }
}
.h-full {
  height: 100vh;
}

.w-full {
  width: 100%;
}

.flex {
  display: flex;
}

.flex-col {
  flex-direction: column;
}

.flex-row {
  flex-direction: row;
}

.flex-wrap {
  flex-wrap: wrap;
}

.flex-nowrap {
  flex-wrap: nowrap;
}

.items-center {
  align-items: center;
}

.justify-center {
  justify-content: center;
}

.justify-between {
  justify-content: space-between;
}

.text-center {
  text-align: center;
}

.bg-black {
  background-color: var(--color-black);
}

.text-white {
  color: var(--color-white);
}

.mx-mobile {
  margin: 1rem 0;
}

.mt-2 {
  margin-top: 1rem;
}

.mt-3 {
  margin-top: 2rem;
}

.mt-4 {
  margin-top: 3rem;
}

.mb-2 {
  margin-bottom: 1rem !important;
}

.mb-3 {
  margin-bottom: 2rem !important;
}

.mb-4 {
  margin-bottom: 3rem !important;
}

.my-max {
  margin: 5rem 0;
}

.min-h-full {
  min-height: calc(100vh - 63px - 60px);
  padding-top: 60px !important;
}
@media screen and (min-width: 1200px) {
  .min-h-full {
    min-height: calc(100vh - 63px);
    padding-top: 100px !important;
  }
}

.container {
  padding: 60px 0;
}

.w-50 {
  width: 100%;
}
@media screen and (min-width: 1200px) {
  .w-50 {
    width: 50%;
  }
}

.no-scroll {
  overflow: hidden;
}

.MuiFormControl-root,
.MuiInputBase-root {
  width: 100% !important;
  color: white;
}
@media screen and (min-width: 1200px) {
  .MuiFormControl-root.w-50,
  .MuiInputBase-root.w-50 {
    width: 50% !important;
  }
}

.MuiFormHelperText-root {
  padding-right: 1rem;
  color: #858585 !important;
  margin-top: 10px !important;
  letter-spacing: 0.1px !important;
}

.MuiInput-underline::before {
  border-bottom: 1px solid white !important;
}

.MuiInput-underline::after {
  border-bottom: 2px solid white !important;
}

.MuiInput-underline.Mui-error::before {
  border-bottom: 1px solid rgb(255, 83, 83) !important;
}

.MuiInput-underline.Mui-error::after {
  border-bottom: 2px solid rgb(255, 83, 83) !important;
}

.MuiInputBase-input {
  padding: 4px 0 13px !important;
  font-size: 19px !important;
}

.MuiInputLabel-formControl,
.MuiInputBase-input,
.MuiSelect-icon,
.MuiTypography-colorPrimary {
  top: -10px !important;
  color: white !important;
}

.MuiOutlinedInput-notchedOutline {
  border-color: white !important;
}

.Mui-error .MuiOutlinedInput-notchedOutline {
  border-color: rgb(255, 83, 83) !important;
}

.MuiButton-root {
  line-height: 1.1 !important;
}

.MuiButton-root:hover .MuiSvgIcon-root {
  color: black !important;
}

.MuiButton-root:hover .MuiCircularProgress-root {
  color: black !important;
}

.MuiContainer-root {
  display: flex !important;
  justify-content: center;
  align-items: center;
}

#email-helper-text,
#password-helper-text {
  color: rgb(248, 132, 132) !important;
  margin: 0;
}

table {
  background: #000000;
}

.MuiTableCell-body,
.MuiTableCell-head {
  color: white !important;
}

.apexcharts-text tspan {
  color: white;
  font-size: 16px;
}

/* Chrome, Safari, Edge, Opera */
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}

.mui-checkbox .MuiIconButton-colorPrimary {
  color: #fff !important;
}
.mui-checkbox .MuiFormControlLabel-label {
  color: #fff !important;
}

.MuiInputBase-input:-internal-autofill-selected {
  background: black !important;
}

.MuiInputBase-input:-webkit-autofill,
.MuiInputBase-input:-webkit-autofill:hover,
.MuiInputBase-input:-webkit-autofill:focus,
.MuiInputBase-input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px black inset !important;
  -webkit-text-fill-color: white !important;
}

.MuiSelect-selectMenu {
  padding: 4px 24px 13px 0 !important;
}

button.react-datepicker__close-icon {
  border: 0 !important;
}
button.react-datepicker__close-icon::after {
  font-size: 25px;
  font-weight: 1000;
  background-color: transparent !important;
}
button.react-datepicker__close-icon:hover {
  background-color: transparent !important;
}
button.react-datepicker__close-icon:hover::after {
  color: var(--color-yellow) !important;
}

button.react-datepicker__navigation.react-datepicker__navigation--next {
  border: none !important;
}

button.react-datepicker__navigation.react-datepicker__navigation--next {
  border: none !important;
}
button.react-datepicker__navigation.react-datepicker__navigation--next .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next {
  width: 0 !important;
}
button.react-datepicker__navigation.react-datepicker__navigation--next .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next:before {
  border-color: black !important;
  margin-top: 5px;
}
button.react-datepicker__navigation.react-datepicker__navigation--next:hover {
  background-color: transparent !important;
}

button.react-datepicker__navigation.react-datepicker__navigation--previous {
  border: none !important;
}
button.react-datepicker__navigation.react-datepicker__navigation--previous .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous {
  width: 0 !important;
}
button.react-datepicker__navigation.react-datepicker__navigation--previous .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous:before {
  border-color: black !important;
  margin-top: 5px;
}
button.react-datepicker__navigation.react-datepicker__navigation--previous:hover {
  background-color: transparent !important;
}

.MuiFormLabel-root {
  font-size: 19px !important;
}

.MuiButton-label {
  font-size: 16px;
}
@media (min-width: 720px) {
  .MuiButton-label {
    font-size: 19px;
  }
}

.MuiAlert-action button {
  color: red !important;
  border: 1px solid red !important;
  height: 20px;
  width: 20px;
}
.MuiAlert-action button:hover {
  color: red !important;
  border: 1px solid red !important;
  background-color: transparent !important;
  transform: scale(1.1);
}

.error-table-container table thead tr td,
.error-table-container table thead tr th,
.error-table-container table tbody tr td,
.error-table-container table tbody tr th,
.error-table-container table tfooter tr td,
.error-table-container table tfooter tr th {
  border-color: red !important;
}
.error-table-container table tbody tr td,
.error-table-container table tbody tr th {
  color: red !important;
}

.MuiTableCell-root p {
  font-size: 0.875rem;
}

.MuiAlert-message {
  width: 400px;
}

.MuiTablePagination-root {
  color: white !important;
  background-color: black !important;
}
.MuiTablePagination-root .MuiTypography-colorInherit {
  color: white !important;
}
.MuiTablePagination-root .MuiTablePagination-input {
  width: 200px !important;
}

* {
  font-family: "Haas Grot Disp R Web";
}

body {
  background-color: var(--color-black);
}

button.w-100 {
  width: 100% !important;
}

.secondary-font {
  font-family: "Neuzeit S LT Std", "Sans-serif";
}

.suncorp-font {
  font-family: "Atlas Grotesk", "Arial", "sans-serif";
}

.aami-font {
  font-family: "Futura", "Arial", "sans-serif";
}

.apia-font {
  font-family: "Neue Haas Grotesk";
}

.site-header {
  background: var(--color-black);
  color: var(--color-white);
  height: 60px;
}
@media screen and (min-width: 1200px) {
  .site-header {
    height: 100px;
    width: 100%;
    position: absolute;
    top: 0;
    background: transparent;
    z-index: 100;
  }
}
.site-header .navigation-container {
  width: 100%;
  padding: 16px 18px 0;
  top: 0;
  z-index: 1;
  background: var(--color-black);
  font-family: "Haas Grot Disp";
  height: 60px;
}
@media screen and (min-width: 1200px) {
  .site-header .navigation-container {
    height: 100px;
    padding: 20px 25px;
    background: transparent;
  }
}
.site-header .navigation-container.scroll {
  padding: 20px 25px 0;
  position: fixed;
  background: black;
}
.site-header .navigation-container .navbar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
}
.site-header .navigation-container .navbar .navbar-logo {
  width: 100px;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu {
  display: flex;
  flex-direction: column;
  background: #222222;
  width: 100%;
  height: 100%;
  flex-wrap: wrap;
  top: -150%;
  left: 0;
  position: fixed;
  opacity: 1;
  transition: all 0.5s ease;
}
@media screen and (min-width: 1200px) {
  .site-header .navigation-container .navbar .site-header-navigation ul.primary-menu {
    position: unset;
    height: auto;
    width: auto;
    align-items: center;
    flex-direction: row;
    justify-content: center;
    padding: 15px 29px 19px;
    margin: 0;
    border-radius: 11px;
    box-shadow: 0 9px 20px #222;
  }
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active {
  padding: 10px 16px 10px 16px;
  margin-top: 0;
  top: 57px;
  z-index: 1;
  transition: all 0.5s ease;
  background-color: var(--color-black);
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active li {
  margin: 13px 0 0 0;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active li a {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active li a .navigation-more {
  display: block;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active li.main-navigation-search {
  display: none;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li {
  list-style: none;
  margin-right: 57px;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li:nth-last-child(1) {
  margin-right: 0;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a {
  font-size: 19px;
  line-height: 26px;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a:hover {
  color: var(--color-yellow);
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a {
  display: flex;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a .navigation-more {
  display: none;
}
.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a.active {
  color: var(--color-yellow);
}
.site-header .navigation-container .navbar .site-header-profile {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.site-header .navigation-container .navbar .site-header-profile .dots-icon-holder .navigation-dots {
  cursor: pointer;
  margin-left: 19px;
}
@media screen and (min-width: 1200px) {
  .site-header .navigation-container .navbar .site-header-profile .dots-icon-holder {
    display: none;
  }
}
.site-header .navigation-container .navbar .site-header-profile .search-icon-holder .navigation-search {
  cursor: pointer;
  margin-right: 19px;
}
@media screen and (min-width: 1200px) {
  .site-header .navigation-container .navbar .site-header-profile .search-icon-holder {
    display: none;
  }
}
.site-header .navigation-container .navbar .site-header-profile .profile-icon-holder .dropdown-icon {
  margin-left: -3px;
}
@media screen and (min-width: 1200px) {
  .site-header .navigation-container .navbar .site-header-profile .profile-icon-holder .dropdown-icon {
    margin-left: 0;
  }
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder {
  z-index: 10;
  top: 25px !important;
  left: unset !important;
  right: 0;
  transform: unset !important;
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .MuiPaper-rounded {
  border-radius: 20px !important;
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li {
  padding: 16px;
  background-color: transparent;
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li:hover {
  background-color: transparent;
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li p {
  color: var(--color-black);
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li.logout-item {
  display: flex;
  justify-content: center;
  transition: all 0.3s linear;
  background-color: #222;
  border-radius: 50px;
  margin: 8px;
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li.logout-item span {
  color: var(--color-yellow);
  width: 100%;
  text-align: center;
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li.logout-item:hover {
  background-color: #8F8F8F;
}
.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li.logout-item:hover span {
  color: var(--color-yellow);
}

:root {
  --color-white: #ffffff;
  --color-black: #000000;
  --color-grey: #8f8f8f;
  --color-yellow: #fffb00;
  --color-red: red;
  --h1-fs: 50px;
  --h1-lh: 55px;
  --h2-fs: 38px;
  --h2-lh: 41px;
  --nav-fs: 19px;
  --nav-lh: 25px;
  --body-fs: 14px;
  --body-lh: 19px;
  --table-fs: 14px;
  --table-lh: 16px;
  --subtitle-fs: 14px;
  --subtitle-lh: 16px;
  --fw-light: 300;
  --fw-normal: 400;
  --fw-medium: 500;
  --fw-semibold: 600;
  --fw-bold: 700;
}

@media (max-width: 768px) {
  :root {
    --h1-fs: 40px;
    --h1-lh: 45px;
    --h2-fs: 30px;
    --h2-lh: 35px;
    --nav-fs: 19px;
    --nav-lh: 25px;
    --body-fs: 16px;
    --body-lh: 22px;
    --table-fs: 14px;
    --table-lh: 16px;
    --subtitle-fs: 12px;
    --subtitle-lh: 16px;
  }
}
button {
  background: transparent !important;
  color: var(--color-yellow) !important;
  text-transform: capitalize !important;
  border: 1px solid var(--color-yellow) !important;
  border-radius: 30px !important;
  height: 48px;
  padding: 1rem 0.5rem;
  font-size: var(--body-fs);
  font-weight: var(--fw-medium);
}
button .MuiButton-label {
  font-size: 18px;
}
button:hover {
  background: var(--color-yellow) !important;
  color: var(--color-black) !important;
}
button.large {
  min-width: 336px;
}
button.small {
  min-width: 192px;
}
button.deactivate-btn {
  color: var(--color-red) !important;
  border: 2px solid var(--color-red) !important;
  margin-top: 5px;
}
button.deactivate-btn:hover {
  background: var(--color-red) !important;
  color: var(--color-black) !important;
}
button.deactivate-btn .MuiButton-label {
  font-size: var(--table-fs);
}
button.resend-email-btn {
  margin-top: 5px;
}
button.resend-email-btn .MuiButton-label {
  font-size: var(--table-fs);
}

footer.site-footer {
  background: var(--color-black);
  border-top: 0.5px solid #fff;
  padding: 17px 25px 19px;
}
footer.site-footer p {
  font-size: 19px;
  font-family: "Haas Grot Disp";
  line-height: 25px;
}

.dialog-action-btn {
  color: black !important;
}

.MuiDialog-container .MuiDialog-paper {
  background-color: #000;
  color: #fff;
  border: 1px solid #fff;
  border-radius: 10px;
  padding: 30px 60px 60px 60px;
  min-width: 700px;
}
.MuiDialog-container .MuiDialog-paper .MuiCircularProgress-root {
  color: var(--color-yellow) !important;
}
.MuiDialog-container .MuiDialog-paper .MuiDialogTitle-root .MuiTypography-root {
  color: #fff;
  font-size: 38px;
  font-weight: normal;
  text-align: center;
}
.MuiDialog-container .MuiDialog-paper .MuiDialogContent-root .MuiTypography-root {
  color: #fff;
  font-size: 20px;
  text-align: center;
  font-weight: 300;
  margin-bottom: 50px;
}
.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root,
.MuiDialog-container .MuiDialog-paper .MuiDialogContentText-root {
  justify-content: space-evenly;
}
.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root .MuiButtonBase-root,
.MuiDialog-container .MuiDialog-paper .MuiDialogContentText-root .MuiButtonBase-root {
  width: 40%;
}
.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root .MuiButtonBase-root .MuiButton-label,
.MuiDialog-container .MuiDialog-paper .MuiDialogContentText-root .MuiButtonBase-root .MuiButton-label {
  color: yellow;
}
.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root .MuiButtonBase-root:hover .MuiButton-label,
.MuiDialog-container .MuiDialog-paper .MuiDialogContentText-root .MuiButtonBase-root:hover .MuiButton-label {
  color: #000;
}

.ReactModal__Overlay--after-open {
  z-index: 101;
}

.modal {
  background-color: black;
  color: red;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  padding: 45px 65px 65px 65px;
  text-align: center;
  width: 90vw;
  overflow: auto;
  border: 1px solid #fff;
  border-radius: 10px;
  max-height: 100%;
}
.modal h2 {
  font-size: 38px;
}
.modal .note-table-wrapper {
  margin: 20px 0px;
}
.modal .close-icon {
  display: flex;
  justify-content: flex-end;
  padding: 0px 10px;
  cursor: pointer;
  color: white;
}
.modal .find-code-image-wrapper {
  display: flex;
  justify-content: center;
}
.modal .detail-log-wrapper {
  display: flex;
  gap: 10px;
  margin-top: 20px;
}
.modal .detail-log-wrapper .detail-log-info {
  display: flex;
  width: 500px;
  background-color: floralwhite;
  text-align: left;
  overflow: auto;
}
@media screen and (min-width: 480px) {
  .modal {
    width: 450px;
  }
}
@media screen and (min-width: 768px) {
  .modal {
    width: 750px;
    padding: 45px 95px 65px 95px;
  }
}
.modal .bulkCardActionsForms {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 13px 0px;
  text-align: left;
}
.modal .upload-file-container {
  margin: 17px;
}
.modal .upload-file-container .file-upload-btn {
  color: white;
  border: 2px solid white;
  border-radius: 30px;
  width: 192px;
  height: 48px;
  text-transform: unset;
}
.modal .upload-file-container .file-upload-btn:hover {
  color: var(--color-yellow);
  border: 2px solid var(--color-yellow);
}
.modal .upload-file-container .file-upload-btn:hover .MuiSvgIcon-root {
  color: var(--color-yellow) !important;
}
.modal .upload-file-container .file-upload-message {
  display: flex;
  align-items: center;
  margin-left: 10px;
  color: #fff;
}
.modal .cardActionsForms {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin: 13px 0px;
  text-align: left;
}
@media screen and (min-width: 768px) {
  .modal .cardActionsForms {
    flex-direction: row;
  }
}
.modal .accordionWrapper {
  background-color: rgba(0, 0, 0, 0) !important;
  color: #ffffff !important;
  margin-top: 30px;
  max-height: 300px;
  overflow-y: auto;
}
.modal .accordionWrapper .accordionHeading {
  color: #ffffff !important;
  font-size: 22px;
}
.modal .accordionWrapper .accordionDetails {
  flex-direction: column;
  gap: 20px;
}
.modal .accordionWrapper .accordionFields {
  display: flex;
  gap: 10px;
}
.modal .button-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 50px;
}
.modal .button-container button {
  width: 45%;
}
.modal .downloadFile {
  cursor: pointer;
  color: #fff;
}
.modal .field-button-container {
  display: flex;
}
.modal .field-button-container .date-container {
  width: 100%;
  text-align: left;
}
@media screen and (min-width: 768px) {
  .modal .field-button-container .date-container {
    margin-right: 24px;
  }
}
.modal .field-button-container .date-container span {
  color: white;
  width: 100px;
  font-size: 19px;
}
.modal .field-button-container .date-container .date-picker-field {
  background-color: black;
  border: none;
  border-bottom: 1px solid white;
  min-width: 240px;
  width: 100%;
  color: white;
}
.modal .date-container {
  text-align: left;
}
@media screen and (min-width: 768px) {
  .modal .date-container {
    margin-right: 24px;
  }
}
.modal .date-container span {
  color: white;
  width: 100px;
  font-size: 19px;
}
.modal .date-container .date-picker-field {
  background-color: black;
  border: none;
  border-bottom: 1px solid white;
  min-width: 240px;
  width: 100%;
  color: white;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.75);
}

.card-issued-summary-text {
  color: white;
  font-size: 20px;
  margin: 20px;
}

.card-cancelled-summary-header {
  color: white;
  font-size: 20px;
  margin: 20px;
}

.card-cancelled-summary-text {
  color: white;
  font-size: 20px;
  margin: 20px;
}`, "",{"version":3,"sources":["webpack://./src/assets/scss/fonts/fonts.scss","webpack://./src/App.scss","webpack://./src/assets/scss/_reset.scss","webpack://./src/assets/scss/_variables.scss","webpack://./src/assets/scss/_typography.scss","webpack://./src/assets/scss/_layout.scss","webpack://./src/assets/scss/_mixins.scss","webpack://./src/assets/scss/_customClasses.scss","webpack://./src/assets/scss/_overrideMui.scss","webpack://./src/assets/scss/_global.scss","webpack://./src/assets/scss/components/navbar.scss","webpack://./src/assets/scss/components/_button.scss","webpack://./src/assets/scss/components/_footer.scss","webpack://./src/assets/scss/components/_dialog.scss","webpack://./src/assets/scss/components/_modal.scss"],"names":[],"mappings":"AAAA;;;;;;;;;;CAAA;AAYA;EACE,4BAAA;EACA,oHAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACAF;ADGA;EACE,4BAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACFF;ADKA;EACE,qBAAA;EACA,oHAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACHF;ADMA;EACE,qBAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACLF;ADQA;EACE,mCAAA;EACA,oHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACPF;ADUA;EACE,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACRF;;ADWA;EACE,mCAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACTF;ADYA;EACE,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACVF;;ADaA;EACE,mCAAA;EACA,sHAAA;EAEA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACXF;ADcA;EACE,mCAAA;EACA,gBAAA;EACA,kBAAA;EACA,oBAAA;ACZF;;ADeA;EACE,+BAAA;EACA,sHAAA;EACA,gBAAA;ACZF;ADeA;EACE,+BAAA;EACA,sHAAA;EACA,gBAAA;ACbF;ADgBA;EACE,gCAAA;EACA,sHAAA;EACA,gBAAA;ACdF;ADiBA;EACE,gCAAA;EACA,sHAAA;EACA,gBAAA;ACfF;ADkBA;EACE,gCAAA;EACA,sHAAA;EACA,gBAAA;AChBF;ACzGA,eAAA;AACA;;;EAGE,sBAAA;AD2GF;;ACxGA,kBAAA;AACA;;;;;;;EAOE,SAAA;EACA,sBAAA;AD2GF;;ACxGA,oBAAA;AACA;EACE,gBAAA;EACA,iBAAA;AD2GF;;ACxGA,oCAAA;AACA;EACE,eAAA;EACA,cAAA;AD2GF;;ACxGA,2CAAA;AACA;;;;EAIE,aAAA;AD2GF;;ACxGA,wDAAA;AACA;EACE;;;IAGE,qCAAA;IACA,uCAAA;IACA,sCAAA;IACA,gCAAA;ED2GF;AACF;AE3JA;EAEE,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EAIA,aAAA;EACA,aAAA;EAEA,aAAA;EACA,aAAA;EAEA,cAAA;EACA,cAAA;EAEA,eAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,mBAAA;EAIA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AFiJF;;AE/IA;EACE;IACE,aAAA;IACA,aAAA;IAEA,aAAA;IACA,aAAA;IAEA,cAAA;IACA,cAAA;IAEA,eAAA;IACA,eAAA;IAEA,gBAAA;IACA,gBAAA;IAEA,mBAAA;IACA,mBAAA;EF6IF;AACF;AEpMA;EAEE,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EAIA,aAAA;EACA,aAAA;EAEA,aAAA;EACA,aAAA;EAEA,cAAA;EACA,cAAA;EAEA,eAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,mBAAA;EAIA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AF0LF;;AExLA;EACE;IACE,aAAA;IACA,aAAA;IAEA,aAAA;IACA,aAAA;IAEA,cAAA;IACA,cAAA;IAEA,eAAA;IACA,eAAA;IAEA,gBAAA;IACA,gBAAA;IAEA,mBAAA;IACA,mBAAA;EFsLF;AACF;AG3OA;EACE,uBAAA;EACA,yBAAA;AH6OF;;AG1OA;EACE,uBAAA;EACA,yBAAA;AH6OF;;AG1OA;EACE,yBAAA;EACA,2BAAA;AH6OF;;AG3OA;;;EAGE,6BAAA;EACA,yBAAA;AH8OF;;AG5OA;;EAEE,qBAAA;EACA,yBAAA;EACA,6BAAA;EACA,yBAAA;EACA,2BAAA;AH+OF;;AG7OA;EACE,2BAAA;AHgPF;AG/OE;EACE,0BAAA;AHiPJ;;AIhRA;EACE,iBAAA;AJmRF;AK/QI;EDCA;IACE,iBAAA;EJiRJ;AACF;AE3RA;EAEE,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EAIA,aAAA;EACA,aAAA;EAEA,aAAA;EACA,aAAA;EAEA,cAAA;EACA,cAAA;EAEA,eAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,mBAAA;EAIA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AFiRF;;AE/QA;EACE;IACE,aAAA;IACA,aAAA;IAEA,aAAA;IACA,aAAA;IAEA,cAAA;IACA,cAAA;IAEA,eAAA;IACA,eAAA;IAEA,gBAAA;IACA,gBAAA;IAEA,mBAAA;IACA,mBAAA;EF6QF;AACF;AMlUA;EACE,aAAA;ANoUF;;AMlUA;EACE,WAAA;ANqUF;;AMnUA;EACE,aAAA;ANsUF;;AMpUA;EACE,sBAAA;ANuUF;;AMrUA;EACE,mBAAA;ANwUF;;AMtUA;EACE,eAAA;ANyUF;;AMvUA;EACE,iBAAA;AN0UF;;AMxUA;EACE,mBAAA;AN2UF;;AMzUA;EACE,uBAAA;AN4UF;;AM1UA;EACE,8BAAA;AN6UF;;AM3UA;EACE,kBAAA;AN8UF;;AM5UA;EACE,oCAAA;AN+UF;;AM7UA;EACE,yBAAA;ANgVF;;AM9UA;EACE,cAAA;ANiVF;;AM/UA;EACE,gBAAA;ANkVF;;AMhVA;EACE,gBAAA;ANmVF;;AMjVA;EACE,gBAAA;ANoVF;;AMlVA;EACE,8BAAA;ANqVF;;AMnVA;EACE,8BAAA;ANsVF;;AMpVA;EACE,8BAAA;ANuVF;;AMrVA;EACE,cAAA;ANwVF;;AMtVA;EACE,qCAAA;EACA,4BAAA;ANyVF;AMxVE;EAHF;IAII,8BAAA;IACA,6BAAA;EN2VF;AACF;;AMzVA;EACE,eAAA;AN4VF;;AM1VA;EACE,WAAA;AN6VF;AM5VE;EAFF;IAGI,UAAA;EN+VF;AACF;;AM7VA;EACE,gBAAA;ANgWF;;AOnbA;;EAEE,sBAAA;EACA,YAAA;APsbF;AOnbI;EADF;;IAEI,qBAAA;EPubJ;AACF;;AOnbA;EACE,mBAAA;EACA,yBAAA;EACA,2BAAA;EACA,gCAAA;APsbF;;AOnbA;EACE,yCAAA;APsbF;;AOlbA;EACE,yCAAA;APqbF;;AOjbA;EACE,oDAAA;APobF;;AOjbA;EACE,oDAAA;APobF;;AOjbA;EACE,8BAAA;EACA,0BAAA;APobF;;AOjbA;;;;EAIE,qBAAA;EACA,uBAAA;APobF;;AOjbA;EACE,8BAAA;APobF;;AOjbA;EACE,yCAAA;APobF;;AOjbA;EACE,2BAAA;APobF;;AOjbA;EACE,uBAAA;APobF;;AOjbA;EACE,uBAAA;APobF;;AOjbA;EACE,wBAAA;EACA,uBAAA;EACA,mBAAA;APobF;;AOjbA;;EAEE,oCAAA;EACA,SAAA;APobF;;AOjbA;EACE,mBAAA;APobF;;AOjbA;;EAEE,uBAAA;APobF;;AOjbA;EACE,YAAA;EACA,eAAA;APobF;;AOjbA,gCAAA;AACA;;EAEE,wBAAA;EACA,SAAA;APobF;;AOjbA,YAAA;AACA;EACE,0BAAA;APobF;;AO9aE;EACE,sBAAA;APibJ;AO9aE;EACE,sBAAA;APgbJ;;AO5aA;EACE,4BAAA;AP+aF;;AO5aA;;;;EAIE,qDAAA;EACA,yCAAA;AP+aF;;AOpaA;EACE,mCAAA;APuaF;;AOpaA;EACE,oBAAA;APuaF;AOraE;EACE,eAAA;EACA,iBAAA;EACA,wCAAA;APuaJ;AOpaE;EACE,wCAAA;APsaJ;AOpaI;EACE,qCAAA;APsaN;;AOjaA;EACE,uBAAA;APoaF;;AOjaA;EACE,uBAAA;APoaF;AOlaE;EACE,mBAAA;APoaJ;AOlaI;EACE,8BAAA;EACA,eAAA;APoaN;AOhaE;EACE,wCAAA;APkaJ;;AO9ZA;EACE,uBAAA;APiaF;AO/ZE;EACE,mBAAA;APiaJ;AO/ZI;EACE,8BAAA;EACA,eAAA;APiaN;AO7ZE;EACE,wCAAA;AP+ZJ;;AO3ZA;EACE,0BAAA;AP8ZF;;AO3ZA;EACE,eAAA;AP8ZF;AO5ZE;EAHF;IAII,eAAA;EP+ZF;AACF;;AO3ZE;EACE,qBAAA;EACA,gCAAA;EACA,YAAA;EACA,WAAA;AP8ZJ;AO5ZI;EACE,qBAAA;EACA,gCAAA;EACA,wCAAA;EACA,qBAAA;AP8ZN;;AOhZQ;;;;;;EAEE,4BAAA;APuZV;AO/YQ;;EAEE,qBAAA;APiZV;;AO1YA;EACE,mBAAA;AP6YF;;AO1YA;EACE,YAAA;AP6YF;;AO1YA;EACE,uBAAA;EACA,kCAAA;AP6YF;AO5YE;EACE,uBAAA;AP8YJ;AO5YE;EACE,uBAAA;AP8YJ;;AQ5pBA;EACE,mCAAA;AR+pBF;;AQ5pBA;EACE,oCAAA;AR+pBF;;AQ7pBA;EACE,sBAAA;ARgqBF;;AQ7pBA;EACE,6CAAA;ARgqBF;;AQ7pBA;EACE,mDAAA;ARgqBF;;AQ7pBA;EACE,4CAAA;ARgqBF;;AQ7pBA;EACE,gCAAA;ARgqBF;;ASzrBA;EACI,8BAAA;EACA,yBAAA;EACA,YAAA;AT4rBJ;AS3rBI;EAJJ;IAKQ,aAAA;IACA,WAAA;IACA,kBAAA;IACA,MAAA;IACA,uBAAA;IACA,YAAA;ET8rBN;AACF;AS7rBI;EACI,WAAA;EACA,oBAAA;EAEA,MAAA;EACA,UAAA;EACA,8BAAA;EACA,6BAAA;EACA,YAAA;AT8rBR;AS7rBQ;EATJ;IAUQ,aAAA;IACA,kBAAA;IACA,uBAAA;ETgsBV;AACF;AS/rBQ;EACI,oBAAA;EACA,eAAA;EACA,iBAAA;ATisBZ;AS/rBQ;EACI,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;ATisBZ;AShsBY;EACI,YAAA;ATksBhB;AS/rBgB;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,OAAA;EACA,eAAA;EACA,UAAA;EACA,yBAAA;ATisBpB;AShsBoB;EAZJ;IAaQ,eAAA;IACA,YAAA;IACA,WAAA;IACA,mBAAA;IACA,mBAAA;IACA,uBAAA;IACA,uBAAA;IACA,SAAA;IACA,mBAAA;IACA,2BAAA;ETmsBtB;AACF;ASlsBoB;EACI,4BAAA;EACA,aAAA;EACA,SAAA;EACA,UAAA;EACA,yBAAA;EACA,oCAAA;ATosBxB;ASnsBwB;EACI,kBAAA;ATqsB5B;ASpsB4B;EACI,WAAA;EACA,aAAA;EACA,8BAAA;ATssBhC;ASrsBgC;EACI,cAAA;ATusBpC;ASpsB4B;EACI,aAAA;ATssBhC;ASlsBoB;EACI,gBAAA;EACA,kBAAA;ATosBxB;ASnsBwB;EACI,eAAA;ATqsB5B;ASnsBwB;EACI,eAAA;EACA,iBAAA;ATqsB5B;ASpsB4B;EACI,0BAAA;ATssBhC;AS1sBwB;EAMI,aAAA;ATusB5B;AStsB4B;EACI,aAAA;ATwsBhC;AStsB4B;EACI,0BAAA;ATwsBhC;ASlsBY;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;ATosBhB;ASlsBoB;EACI,eAAA;EACA,iBAAA;ATosBxB;ASlsBoB;EALJ;IAMQ,aAAA;ETqsBtB;AACF;ASlsBoB;EACI,eAAA;EACA,kBAAA;ATosBxB;ASlsBoB;EALJ;IAMQ,aAAA;ETqsBtB;AACF;ASlsBoB;EACI,iBAAA;ATosBxB;ASnsBwB;EAFJ;IAGQ,cAAA;ETssB1B;AACF;ASnsBgB;EACI,WAAA;EACA,oBAAA;EACA,sBAAA;EACA,QAAA;EACA,2BAAA;ATqsBpB;ASpsBoB;EACI,8BAAA;ATssBxB;ASnsBwB;EACI,aAAA;EACA,6BAAA;ATqsB5B;ASpsB4B;EACI,6BAAA;ATssBhC;ASpsB4B;EACI,yBAAA;ATssBhC;ASpsB4B;EACI,aAAA;EACA,uBAAA;EACA,2BAAA;EACA,sBAAA;EACA,mBAAA;EACA,WAAA;ATssBhC;ASrsBgC;EACI,0BAAA;EACA,WAAA;EACA,kBAAA;ATusBpC;ASpsBgC;EACI,yBAAA;ATssBpC;ASrsBoC;EACI,0BAAA;ATusBxC;;AEt3BA;EAEE,sBAAA;EACA,sBAAA;EACA,qBAAA;EACA,uBAAA;EACA,gBAAA;EAIA,aAAA;EACA,aAAA;EAEA,aAAA;EACA,aAAA;EAEA,cAAA;EACA,cAAA;EAEA,eAAA;EACA,eAAA;EAEA,gBAAA;EACA,gBAAA;EAEA,mBAAA;EACA,mBAAA;EAIA,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AF62BF;;AE32BA;EACE;IACE,aAAA;IACA,aAAA;IAEA,aAAA;IACA,aAAA;IAEA,cAAA;IACA,cAAA;IAEA,eAAA;IACA,eAAA;IAEA,gBAAA;IACA,gBAAA;IAEA,mBAAA;IACA,mBAAA;EFy2BF;AACF;AU95BA;EACE,kCAAA;EACA,qCAAA;EACA,qCAAA;EACA,gDAAA;EACA,8BAAA;EACA,YAAA;EACA,oBAAA;EACA,yBAAA;EACA,6BAAA;AVg6BF;AU95BE;EACE,eAAA;AVg6BJ;AU75BE;EACE,0CAAA;EACA,oCAAA;AV+5BJ;AU55BE;EACE,gBAAA;AV85BJ;AU35BE;EACE,gBAAA;AV65BJ;AU15BE;EACE,kCAAA;EACA,6CAAA;EACA,eAAA;AV45BJ;AU15BI;EACE,uCAAA;EACA,oCAAA;AV45BN;AUz5BI;EACE,0BAAA;AV25BN;AUv5BE;EACE,eAAA;AVy5BJ;AUv5BI;EACE,0BAAA;AVy5BN;;AW18BA;EACI,8BAAA;EACA,4BAAA;EACA,uBAAA;AX68BJ;AW58BI;EACI,eAAA;EACA,6BAAA;EACA,iBAAA;AX88BR;;AYr9BA;EACI,uBAAA;AZw9BJ;;AYp9BA;EACI,sBAAA;EACA,WAAA;EACA,sBAAA;EACA,mBAAA;EACA,4BAAA;EACA,gBAAA;AZu9BJ;AYr9BI;EACI,qCAAA;AZu9BR;AYp9BI;EACI,WAAA;EACA,eAAA;EACA,mBAAA;EACA,kBAAA;AZs9BR;AYn9BI;EACI,WAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AZq9BR;AYl9BI;;EAEI,6BAAA;AZo9BR;AYl9BQ;;EACI,UAAA;AZq9BZ;AYn9BY;;EACI,aAAA;AZs9BhB;AYn9BY;;EACI,WAAA;AZs9BhB;;AalgCA;EACI,YAAA;AbqgCJ;;Aa9/BA;EACI,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,4BAAA;EACA,kBAAA;EACA,WAAA;EACA,cAAA;EACA,sBAAA;EACA,mBAAA;EACA,gBAAA;AbigCJ;Aa//BI;EACI,eAAA;AbigCR;Aa9/BI;EACI,gBAAA;AbggCR;Aa7/BI;EACI,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,eAAA;EACA,YAAA;Ab+/BR;Aa5/BI;EACI,aAAA;EACA,uBAAA;Ab8/BR;Aa3/BI;EACI,aAAA;EACA,SAAA;EACA,gBAAA;Ab6/BR;Aa3/BQ;EACI,aAAA;EACA,YAAA;EACA,6BAAA;EACA,gBAAA;EACA,cAAA;Ab6/BZ;Aaz/BI;EAlDJ;IAoDQ,YAAA;Eb2/BN;AACF;Aaz/BI;EAvDJ;IAwDQ,YAAA;IACA,4BAAA;Eb4/BN;AACF;Aa1/BI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;Ab4/BR;Aaz/BI;EACI,YAAA;Ab2/BR;Aaz/BQ;EACI,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,qBAAA;Ab2/BZ;Aaz/BY;EACI,0BAAA;EACA,qCAAA;Ab2/BhB;Aaz/BgB;EACI,qCAAA;Ab2/BpB;Aat/BQ;EACI,aAAA;EACA,mBAAA;EACA,iBAAA;EACA,WAAA;Abw/BZ;Aap/BI;EACI,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;EACA,gBAAA;Abs/BR;Aap/BQ;EAPJ;IAQQ,mBAAA;Ebu/BV;AACF;Aap/BI;EACI,6CAAA;EACA,yBAAA;EACA,gBAAA;EACA,iBAAA;EACA,gBAAA;Abs/BR;Aap/BQ;EACI,yBAAA;EACA,eAAA;Abs/BZ;Aan/BQ;EACI,sBAAA;EACA,SAAA;Abq/BZ;Aal/BQ;EACI,aAAA;EACA,SAAA;Abo/BZ;Aah/BI;EACI,aAAA;EACA,eAAA;EACA,8BAAA;EACA,gBAAA;Abk/BR;Aah/BQ;EACI,UAAA;Abk/BZ;Aa9+BI;EACI,eAAA;EACA,WAAA;Abg/BR;Aa7+BI;EACI,aAAA;Ab++BR;Aa7+BQ;EACI,WAAA;EACA,gBAAA;Ab++BZ;Aa7+BY;EAJJ;IAMQ,kBAAA;Eb++Bd;AACF;Aa7+BY;EACI,YAAA;EACA,YAAA;EACA,eAAA;Ab++BhB;Aa5+BY;EACI,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;Ab8+BhB;Aaz+BI;EAEI,gBAAA;Ab0+BR;Aax+BQ;EAJJ;IAMQ,kBAAA;Eb0+BV;AACF;Aax+BQ;EACI,YAAA;EACA,YAAA;EACA,eAAA;Ab0+BZ;Aav+BQ;EACI,uBAAA;EACA,YAAA;EACA,8BAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;Aby+BZ;;Aap+BA;EACI,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,qCAAA;Abu+BJ;;Aap+BA;EACI,YAAA;EACA,eAAA;EACA,YAAA;Abu+BJ;;Aap+BA;EACI,YAAA;EACA,eAAA;EACA,YAAA;Abu+BJ;;Aap+BA;EACI,YAAA;EACA,eAAA;EACA,YAAA;Abu+BJ","sourcesContent":["/*\n        This font software is the property of Commercial Type.\n\n        You may not modify the font software, use it on another website, or install it on a computer.\n\n        License information is available at http://commercialtype.com/eula\n        For more information please visit Commercial Type at http://commercialtype.com or email us at info[at]commercialtype.com\n\n        Copyright (C) 2021 Schwartzco Inc.\n        License: 2109-TPLXSX\n*/\n\n@font-face {\n  font-family: \"Atlas Grotesk\";\n  src: url(\"atlasgrotesk-bold-webfont.woff2\") format(\"woff2\"), url(\"atlasgrotesk-bold-webfont.woff\") format(\"woff\");\n  font-weight: 700;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Atlas Grotesk\";\n  src: url(\"atlasgrotesk-regular-webfont.woff2\") format(\"woff2\"),\n    url(\"atlasgrotesk-regular-webfont.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Futura\";\n  src: url(\"futura-book-bt-webfont.woff2\") format(\"woff2\"), url(\"futura-book-bt-webfont.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Futura\";\n  src: url(\"futura-bt-webfont.woff2\") format(\"woff2\"),\n    url(\"futura-bt-webfont.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Haas Grot Disp R Web\";\n  src: url(\"NeueHaasGrotDispRound-55Roman-Web.woff2\") format(\"woff2\"),\n    url(\"NeueHaasGrotDispRound-55Roman-Web.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n.NeueHaasGrotDispRound-55Roman-Web {\n  font-family: \"Haas Grot Disp R Web\";\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Haas Grot Text R Web\";\n  src: url(\"NeueHaasGrotTextRound-65Medium-Web.woff2\") format(\"woff2\"),\n    url(\"NeueHaasGrotTextRound-65Medium-Web.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n.NeueHaasGrotTextRound-65Medium-Web {\n  font-family: \"Haas Grot Text R Web\";\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Haas Grot Text R Web\";\n  src: url(\"NeueHaasGrotTextRound-55Roman-Web.woff2\") format(\"woff2\"),\n    url(\"NeueHaasGrotTextRound-55Roman-Web.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n.NeueHaasGrotTextRound-55Roman-Web {\n  font-family: \"Haas Grot Text R Web\";\n  font-weight: 400;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Neuzeit S LT Std\";\n  src: url(\"NeuzeitSLTStd-normal.woff\") format(\"woff\"), url(\"NeuzeitSLTStd-normal.woff2\") format(\"woff2\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Neuzeit S LT Std\";\n  src: url(\"NeuzeitSLTStd-bold.woff\") format(\"woff\"), url(\"NeuzeitSLTStd-bold.woff2\") format(\"woff2\");\n  font-weight: 850;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk\";\n  src: url(\"nhaasgrotesktxpro-55rg-webfont.woff\") format(\"woff\"), url(\"nhaasgrotesktxpro-55rg-webfont.woff2\") format(\"woff2\");\n  font-weight: 400;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk\";\n  src: url(\"nhaasgrotesktxpro-65md-webfont.woff\") format(\"woff\"), url(\"nhaasgrotesktxpro-65md-webfont.woff2\") format(\"woff2\");\n  font-weight: 500;\n}\n\n@font-face {\n  font-family: \"Neue Haas Grotesk\";\n  src: url(\"nhaasgrotesktxpro-75bd-webfont.woff\") format(\"woff\"), url(\"nhaasgrotesktxpro-75bd-webfont.woff2\") format(\"woff2\");\n  font-weight: 700;\n}\n","/*\n        This font software is the property of Commercial Type.\n\n        You may not modify the font software, use it on another website, or install it on a computer.\n\n        License information is available at http://commercialtype.com/eula\n        For more information please visit Commercial Type at http://commercialtype.com or email us at info[at]commercialtype.com\n\n        Copyright (C) 2021 Schwartzco Inc.\n        License: 2109-TPLXSX\n*/\n@font-face {\n  font-family: \"Atlas Grotesk\";\n  src: url(\"atlasgrotesk-bold-webfont.woff2\") format(\"woff2\"), url(\"atlasgrotesk-bold-webfont.woff\") format(\"woff\");\n  font-weight: 700;\n  font-style: normal;\n  font-stretch: normal;\n}\n@font-face {\n  font-family: \"Atlas Grotesk\";\n  src: url(\"atlasgrotesk-regular-webfont.woff2\") format(\"woff2\"), url(\"atlasgrotesk-regular-webfont.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n  font-stretch: normal;\n}\n@font-face {\n  font-family: \"Futura\";\n  src: url(\"futura-book-bt-webfont.woff2\") format(\"woff2\"), url(\"futura-book-bt-webfont.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n@font-face {\n  font-family: \"Futura\";\n  src: url(\"futura-bt-webfont.woff2\") format(\"woff2\"), url(\"futura-bt-webfont.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n  font-stretch: normal;\n}\n@font-face {\n  font-family: \"Haas Grot Disp R Web\";\n  src: url(\"NeueHaasGrotDispRound-55Roman-Web.woff2\") format(\"woff2\"), url(\"NeueHaasGrotDispRound-55Roman-Web.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n.NeueHaasGrotDispRound-55Roman-Web {\n  font-family: \"Haas Grot Disp R Web\";\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Haas Grot Text R Web\";\n  src: url(\"NeueHaasGrotTextRound-65Medium-Web.woff2\") format(\"woff2\"), url(\"NeueHaasGrotTextRound-65Medium-Web.woff\") format(\"woff\");\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n.NeueHaasGrotTextRound-65Medium-Web {\n  font-family: \"Haas Grot Text R Web\";\n  font-weight: 500;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Haas Grot Text R Web\";\n  src: url(\"NeueHaasGrotTextRound-55Roman-Web.woff2\") format(\"woff2\"), url(\"NeueHaasGrotTextRound-55Roman-Web.woff\") format(\"woff\");\n  font-weight: 400;\n  font-style: normal;\n  font-stretch: normal;\n}\n.NeueHaasGrotTextRound-55Roman-Web {\n  font-family: \"Haas Grot Text R Web\";\n  font-weight: 400;\n  font-style: normal;\n  font-stretch: normal;\n}\n\n@font-face {\n  font-family: \"Neuzeit S LT Std\";\n  src: url(\"NeuzeitSLTStd-normal.woff\") format(\"woff\"), url(\"NeuzeitSLTStd-normal.woff2\") format(\"woff2\");\n  font-weight: 400;\n}\n@font-face {\n  font-family: \"Neuzeit S LT Std\";\n  src: url(\"NeuzeitSLTStd-bold.woff\") format(\"woff\"), url(\"NeuzeitSLTStd-bold.woff2\") format(\"woff2\");\n  font-weight: 850;\n}\n@font-face {\n  font-family: \"Neue Haas Grotesk\";\n  src: url(\"nhaasgrotesktxpro-55rg-webfont.woff\") format(\"woff\"), url(\"nhaasgrotesktxpro-55rg-webfont.woff2\") format(\"woff2\");\n  font-weight: 400;\n}\n@font-face {\n  font-family: \"Neue Haas Grotesk\";\n  src: url(\"nhaasgrotesktxpro-65md-webfont.woff\") format(\"woff\"), url(\"nhaasgrotesktxpro-65md-webfont.woff2\") format(\"woff2\");\n  font-weight: 500;\n}\n@font-face {\n  font-family: \"Neue Haas Grotesk\";\n  src: url(\"nhaasgrotesktxpro-75bd-webfont.woff\") format(\"woff\"), url(\"nhaasgrotesktxpro-75bd-webfont.woff2\") format(\"woff2\");\n  font-weight: 700;\n}\n/* Box sizing */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* Reset margins */\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\np {\n  margin: 0;\n  letter-spacing: 0.01em;\n}\n\n/* set up the body */\nbody {\n  line-height: 1.5;\n  min-height: 100vh;\n}\n\n/* make images easier to work with */\nimg {\n  max-width: 100%;\n  display: block;\n}\n\n/* make form elements easier to work with */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* remove animations for people who've turned them off */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n:root {\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-grey: #8f8f8f;\n  --color-yellow: #fffb00;\n  --color-red: red;\n  --h1-fs: 50px;\n  --h1-lh: 55px;\n  --h2-fs: 38px;\n  --h2-lh: 41px;\n  --nav-fs: 19px;\n  --nav-lh: 25px;\n  --body-fs: 14px;\n  --body-lh: 19px;\n  --table-fs: 14px;\n  --table-lh: 16px;\n  --subtitle-fs: 14px;\n  --subtitle-lh: 16px;\n  --fw-light: 300;\n  --fw-normal: 400;\n  --fw-medium: 500;\n  --fw-semibold: 600;\n  --fw-bold: 700;\n}\n\n@media (max-width: 768px) {\n  :root {\n    --h1-fs: 40px;\n    --h1-lh: 45px;\n    --h2-fs: 30px;\n    --h2-lh: 35px;\n    --nav-fs: 19px;\n    --nav-lh: 25px;\n    --body-fs: 16px;\n    --body-lh: 22px;\n    --table-fs: 14px;\n    --table-lh: 16px;\n    --subtitle-fs: 12px;\n    --subtitle-lh: 16px;\n  }\n}\n:root {\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-grey: #8f8f8f;\n  --color-yellow: #fffb00;\n  --color-red: red;\n  --h1-fs: 50px;\n  --h1-lh: 55px;\n  --h2-fs: 38px;\n  --h2-lh: 41px;\n  --nav-fs: 19px;\n  --nav-lh: 25px;\n  --body-fs: 14px;\n  --body-lh: 19px;\n  --table-fs: 14px;\n  --table-lh: 16px;\n  --subtitle-fs: 14px;\n  --subtitle-lh: 16px;\n  --fw-light: 300;\n  --fw-normal: 400;\n  --fw-medium: 500;\n  --fw-semibold: 600;\n  --fw-bold: 700;\n}\n\n@media (max-width: 768px) {\n  :root {\n    --h1-fs: 40px;\n    --h1-lh: 45px;\n    --h2-fs: 30px;\n    --h2-lh: 35px;\n    --nav-fs: 19px;\n    --nav-lh: 25px;\n    --body-fs: 16px;\n    --body-lh: 22px;\n    --table-fs: 14px;\n    --table-lh: 16px;\n    --subtitle-fs: 12px;\n    --subtitle-lh: 16px;\n  }\n}\nh1 {\n  font-size: var(--h1-fs);\n  line-height: var(--h1-lh);\n}\n\nh2 {\n  font-size: var(--h2-fs);\n  line-height: var(--h2-lh);\n}\n\nh3 {\n  font-size: var(--body-fs);\n  line-height: var(--body-lh);\n}\n\nh1,\nh2,\nh3 {\n  font-weight: var(--fw-normal);\n  color: var(--color-white);\n}\n\np,\na {\n  text-decoration: none;\n  color: var(--color-white);\n  font-weight: var(--fw-normal);\n  font-size: var(--body-fs);\n  line-height: var(--body-lh);\n}\n\na {\n  transition: all 0.3s linear;\n}\na:hover {\n  color: var(--color-yellow);\n}\n\n.App {\n  background: black;\n}\n@media only screen and (max-width: 768px) {\n  .App button.small {\n    min-height: 148px;\n  }\n}\n:root {\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-grey: #8f8f8f;\n  --color-yellow: #fffb00;\n  --color-red: red;\n  --h1-fs: 50px;\n  --h1-lh: 55px;\n  --h2-fs: 38px;\n  --h2-lh: 41px;\n  --nav-fs: 19px;\n  --nav-lh: 25px;\n  --body-fs: 14px;\n  --body-lh: 19px;\n  --table-fs: 14px;\n  --table-lh: 16px;\n  --subtitle-fs: 14px;\n  --subtitle-lh: 16px;\n  --fw-light: 300;\n  --fw-normal: 400;\n  --fw-medium: 500;\n  --fw-semibold: 600;\n  --fw-bold: 700;\n}\n\n@media (max-width: 768px) {\n  :root {\n    --h1-fs: 40px;\n    --h1-lh: 45px;\n    --h2-fs: 30px;\n    --h2-lh: 35px;\n    --nav-fs: 19px;\n    --nav-lh: 25px;\n    --body-fs: 16px;\n    --body-lh: 22px;\n    --table-fs: 14px;\n    --table-lh: 16px;\n    --subtitle-fs: 12px;\n    --subtitle-lh: 16px;\n  }\n}\n.h-full {\n  height: 100vh;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.flex {\n  display: flex;\n}\n\n.flex-col {\n  flex-direction: column;\n}\n\n.flex-row {\n  flex-direction: row;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n\n.items-center {\n  align-items: center;\n}\n\n.justify-center {\n  justify-content: center;\n}\n\n.justify-between {\n  justify-content: space-between;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.bg-black {\n  background-color: var(--color-black);\n}\n\n.text-white {\n  color: var(--color-white);\n}\n\n.mx-mobile {\n  margin: 1rem 0;\n}\n\n.mt-2 {\n  margin-top: 1rem;\n}\n\n.mt-3 {\n  margin-top: 2rem;\n}\n\n.mt-4 {\n  margin-top: 3rem;\n}\n\n.mb-2 {\n  margin-bottom: 1rem !important;\n}\n\n.mb-3 {\n  margin-bottom: 2rem !important;\n}\n\n.mb-4 {\n  margin-bottom: 3rem !important;\n}\n\n.my-max {\n  margin: 5rem 0;\n}\n\n.min-h-full {\n  min-height: calc(100vh - 63px - 60px);\n  padding-top: 60px !important;\n}\n@media screen and (min-width: 1200px) {\n  .min-h-full {\n    min-height: calc(100vh - 63px);\n    padding-top: 100px !important;\n  }\n}\n\n.container {\n  padding: 60px 0;\n}\n\n.w-50 {\n  width: 100%;\n}\n@media screen and (min-width: 1200px) {\n  .w-50 {\n    width: 50%;\n  }\n}\n\n.no-scroll {\n  overflow: hidden;\n}\n\n.MuiFormControl-root,\n.MuiInputBase-root {\n  width: 100% !important;\n  color: white;\n}\n@media screen and (min-width: 1200px) {\n  .MuiFormControl-root.w-50,\n  .MuiInputBase-root.w-50 {\n    width: 50% !important;\n  }\n}\n\n.MuiFormHelperText-root {\n  padding-right: 1rem;\n  color: #858585 !important;\n  margin-top: 10px !important;\n  letter-spacing: 0.1px !important;\n}\n\n.MuiInput-underline::before {\n  border-bottom: 1px solid white !important;\n}\n\n.MuiInput-underline::after {\n  border-bottom: 2px solid white !important;\n}\n\n.MuiInput-underline.Mui-error::before {\n  border-bottom: 1px solid rgb(255, 83, 83) !important;\n}\n\n.MuiInput-underline.Mui-error::after {\n  border-bottom: 2px solid rgb(255, 83, 83) !important;\n}\n\n.MuiInputBase-input {\n  padding: 4px 0 13px !important;\n  font-size: 19px !important;\n}\n\n.MuiInputLabel-formControl,\n.MuiInputBase-input,\n.MuiSelect-icon,\n.MuiTypography-colorPrimary {\n  top: -10px !important;\n  color: white !important;\n}\n\n.MuiOutlinedInput-notchedOutline {\n  border-color: white !important;\n}\n\n.Mui-error .MuiOutlinedInput-notchedOutline {\n  border-color: rgb(255, 83, 83) !important;\n}\n\n.MuiButton-root {\n  line-height: 1.1 !important;\n}\n\n.MuiButton-root:hover .MuiSvgIcon-root {\n  color: black !important;\n}\n\n.MuiButton-root:hover .MuiCircularProgress-root {\n  color: black !important;\n}\n\n.MuiContainer-root {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n\n#email-helper-text,\n#password-helper-text {\n  color: rgb(248, 132, 132) !important;\n  margin: 0;\n}\n\ntable {\n  background: #000000;\n}\n\n.MuiTableCell-body,\n.MuiTableCell-head {\n  color: white !important;\n}\n\n.apexcharts-text tspan {\n  color: white;\n  font-size: 16px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type=number] {\n  -moz-appearance: textfield;\n}\n\n.mui-checkbox .MuiIconButton-colorPrimary {\n  color: #fff !important;\n}\n.mui-checkbox .MuiFormControlLabel-label {\n  color: #fff !important;\n}\n\n.MuiInputBase-input:-internal-autofill-selected {\n  background: black !important;\n}\n\n.MuiInputBase-input:-webkit-autofill,\n.MuiInputBase-input:-webkit-autofill:hover,\n.MuiInputBase-input:-webkit-autofill:focus,\n.MuiInputBase-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px black inset !important;\n  -webkit-text-fill-color: white !important;\n}\n\n.MuiSelect-selectMenu {\n  padding: 4px 24px 13px 0 !important;\n}\n\nbutton.react-datepicker__close-icon {\n  border: 0 !important;\n}\nbutton.react-datepicker__close-icon::after {\n  font-size: 25px;\n  font-weight: 1000;\n  background-color: transparent !important;\n}\nbutton.react-datepicker__close-icon:hover {\n  background-color: transparent !important;\n}\nbutton.react-datepicker__close-icon:hover::after {\n  color: var(--color-yellow) !important;\n}\n\nbutton.react-datepicker__navigation.react-datepicker__navigation--next {\n  border: none !important;\n}\n\nbutton.react-datepicker__navigation.react-datepicker__navigation--next {\n  border: none !important;\n}\nbutton.react-datepicker__navigation.react-datepicker__navigation--next .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next {\n  width: 0 !important;\n}\nbutton.react-datepicker__navigation.react-datepicker__navigation--next .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next:before {\n  border-color: black !important;\n  margin-top: 5px;\n}\nbutton.react-datepicker__navigation.react-datepicker__navigation--next:hover {\n  background-color: transparent !important;\n}\n\nbutton.react-datepicker__navigation.react-datepicker__navigation--previous {\n  border: none !important;\n}\nbutton.react-datepicker__navigation.react-datepicker__navigation--previous .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous {\n  width: 0 !important;\n}\nbutton.react-datepicker__navigation.react-datepicker__navigation--previous .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous:before {\n  border-color: black !important;\n  margin-top: 5px;\n}\nbutton.react-datepicker__navigation.react-datepicker__navigation--previous:hover {\n  background-color: transparent !important;\n}\n\n.MuiFormLabel-root {\n  font-size: 19px !important;\n}\n\n.MuiButton-label {\n  font-size: 16px;\n}\n@media (min-width: 720px) {\n  .MuiButton-label {\n    font-size: 19px;\n  }\n}\n\n.MuiAlert-action button {\n  color: red !important;\n  border: 1px solid red !important;\n  height: 20px;\n  width: 20px;\n}\n.MuiAlert-action button:hover {\n  color: red !important;\n  border: 1px solid red !important;\n  background-color: transparent !important;\n  transform: scale(1.1);\n}\n\n.error-table-container table thead tr td,\n.error-table-container table thead tr th,\n.error-table-container table tbody tr td,\n.error-table-container table tbody tr th,\n.error-table-container table tfooter tr td,\n.error-table-container table tfooter tr th {\n  border-color: red !important;\n}\n.error-table-container table tbody tr td,\n.error-table-container table tbody tr th {\n  color: red !important;\n}\n\n.MuiTableCell-root p {\n  font-size: 0.875rem;\n}\n\n.MuiAlert-message {\n  width: 400px;\n}\n\n.MuiTablePagination-root {\n  color: white !important;\n  background-color: black !important;\n}\n.MuiTablePagination-root .MuiTypography-colorInherit {\n  color: white !important;\n}\n.MuiTablePagination-root .MuiTablePagination-input {\n  width: 200px !important;\n}\n\n* {\n  font-family: \"Haas Grot Disp R Web\";\n}\n\nbody {\n  background-color: var(--color-black);\n}\n\nbutton.w-100 {\n  width: 100% !important;\n}\n\n.secondary-font {\n  font-family: \"Neuzeit S LT Std\", \"Sans-serif\";\n}\n\n.suncorp-font {\n  font-family: \"Atlas Grotesk\", \"Arial\", \"sans-serif\";\n}\n\n.aami-font {\n  font-family: \"Futura\", \"Arial\", \"sans-serif\";\n}\n\n.apia-font {\n  font-family: \"Neue Haas Grotesk\";\n}\n\n.site-header {\n  background: var(--color-black);\n  color: var(--color-white);\n  height: 60px;\n}\n@media screen and (min-width: 1200px) {\n  .site-header {\n    height: 100px;\n    width: 100%;\n    position: absolute;\n    top: 0;\n    background: transparent;\n    z-index: 100;\n  }\n}\n.site-header .navigation-container {\n  width: 100%;\n  padding: 16px 18px 0;\n  top: 0;\n  z-index: 1;\n  background: var(--color-black);\n  font-family: \"Haas Grot Disp\";\n  height: 60px;\n}\n@media screen and (min-width: 1200px) {\n  .site-header .navigation-container {\n    height: 100px;\n    padding: 20px 25px;\n    background: transparent;\n  }\n}\n.site-header .navigation-container.scroll {\n  padding: 20px 25px 0;\n  position: fixed;\n  background: black;\n}\n.site-header .navigation-container .navbar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n}\n.site-header .navigation-container .navbar .navbar-logo {\n  width: 100px;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu {\n  display: flex;\n  flex-direction: column;\n  background: #222222;\n  width: 100%;\n  height: 100%;\n  flex-wrap: wrap;\n  top: -150%;\n  left: 0;\n  position: fixed;\n  opacity: 1;\n  transition: all 0.5s ease;\n}\n@media screen and (min-width: 1200px) {\n  .site-header .navigation-container .navbar .site-header-navigation ul.primary-menu {\n    position: unset;\n    height: auto;\n    width: auto;\n    align-items: center;\n    flex-direction: row;\n    justify-content: center;\n    padding: 15px 29px 19px;\n    margin: 0;\n    border-radius: 11px;\n    box-shadow: 0 9px 20px #222;\n  }\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active {\n  padding: 10px 16px 10px 16px;\n  margin-top: 0;\n  top: 57px;\n  z-index: 1;\n  transition: all 0.5s ease;\n  background-color: var(--color-black);\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active li {\n  margin: 13px 0 0 0;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active li a {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active li a .navigation-more {\n  display: block;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu.active li.main-navigation-search {\n  display: none;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li {\n  list-style: none;\n  margin-right: 57px;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li:nth-last-child(1) {\n  margin-right: 0;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a {\n  font-size: 19px;\n  line-height: 26px;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a:hover {\n  color: var(--color-yellow);\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a {\n  display: flex;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a .navigation-more {\n  display: none;\n}\n.site-header .navigation-container .navbar .site-header-navigation ul.primary-menu li a.active {\n  color: var(--color-yellow);\n}\n.site-header .navigation-container .navbar .site-header-profile {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n}\n.site-header .navigation-container .navbar .site-header-profile .dots-icon-holder .navigation-dots {\n  cursor: pointer;\n  margin-left: 19px;\n}\n@media screen and (min-width: 1200px) {\n  .site-header .navigation-container .navbar .site-header-profile .dots-icon-holder {\n    display: none;\n  }\n}\n.site-header .navigation-container .navbar .site-header-profile .search-icon-holder .navigation-search {\n  cursor: pointer;\n  margin-right: 19px;\n}\n@media screen and (min-width: 1200px) {\n  .site-header .navigation-container .navbar .site-header-profile .search-icon-holder {\n    display: none;\n  }\n}\n.site-header .navigation-container .navbar .site-header-profile .profile-icon-holder .dropdown-icon {\n  margin-left: -3px;\n}\n@media screen and (min-width: 1200px) {\n  .site-header .navigation-container .navbar .site-header-profile .profile-icon-holder .dropdown-icon {\n    margin-left: 0;\n  }\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder {\n  z-index: 10;\n  top: 25px !important;\n  left: unset !important;\n  right: 0;\n  transform: unset !important;\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .MuiPaper-rounded {\n  border-radius: 20px !important;\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li {\n  padding: 16px;\n  background-color: transparent;\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li:hover {\n  background-color: transparent;\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li p {\n  color: var(--color-black);\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li.logout-item {\n  display: flex;\n  justify-content: center;\n  transition: all 0.3s linear;\n  background-color: #222;\n  border-radius: 50px;\n  margin: 8px;\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li.logout-item span {\n  color: var(--color-yellow);\n  width: 100%;\n  text-align: center;\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li.logout-item:hover {\n  background-color: #8F8F8F;\n}\n.site-header .navigation-container .navbar .site-header-profile .menu-dropdown-holder .sub-menu-list li.logout-item:hover span {\n  color: var(--color-yellow);\n}\n\n:root {\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-grey: #8f8f8f;\n  --color-yellow: #fffb00;\n  --color-red: red;\n  --h1-fs: 50px;\n  --h1-lh: 55px;\n  --h2-fs: 38px;\n  --h2-lh: 41px;\n  --nav-fs: 19px;\n  --nav-lh: 25px;\n  --body-fs: 14px;\n  --body-lh: 19px;\n  --table-fs: 14px;\n  --table-lh: 16px;\n  --subtitle-fs: 14px;\n  --subtitle-lh: 16px;\n  --fw-light: 300;\n  --fw-normal: 400;\n  --fw-medium: 500;\n  --fw-semibold: 600;\n  --fw-bold: 700;\n}\n\n@media (max-width: 768px) {\n  :root {\n    --h1-fs: 40px;\n    --h1-lh: 45px;\n    --h2-fs: 30px;\n    --h2-lh: 35px;\n    --nav-fs: 19px;\n    --nav-lh: 25px;\n    --body-fs: 16px;\n    --body-lh: 22px;\n    --table-fs: 14px;\n    --table-lh: 16px;\n    --subtitle-fs: 12px;\n    --subtitle-lh: 16px;\n  }\n}\nbutton {\n  background: transparent !important;\n  color: var(--color-yellow) !important;\n  text-transform: capitalize !important;\n  border: 1px solid var(--color-yellow) !important;\n  border-radius: 30px !important;\n  height: 48px;\n  padding: 1rem 0.5rem;\n  font-size: var(--body-fs);\n  font-weight: var(--fw-medium);\n}\nbutton .MuiButton-label {\n  font-size: 18px;\n}\nbutton:hover {\n  background: var(--color-yellow) !important;\n  color: var(--color-black) !important;\n}\nbutton.large {\n  min-width: 336px;\n}\nbutton.small {\n  min-width: 192px;\n}\nbutton.deactivate-btn {\n  color: var(--color-red) !important;\n  border: 2px solid var(--color-red) !important;\n  margin-top: 5px;\n}\nbutton.deactivate-btn:hover {\n  background: var(--color-red) !important;\n  color: var(--color-black) !important;\n}\nbutton.deactivate-btn .MuiButton-label {\n  font-size: var(--table-fs);\n}\nbutton.resend-email-btn {\n  margin-top: 5px;\n}\nbutton.resend-email-btn .MuiButton-label {\n  font-size: var(--table-fs);\n}\n\nfooter.site-footer {\n  background: var(--color-black);\n  border-top: 0.5px solid #fff;\n  padding: 17px 25px 19px;\n}\nfooter.site-footer p {\n  font-size: 19px;\n  font-family: \"Haas Grot Disp\";\n  line-height: 25px;\n}\n\n.dialog-action-btn {\n  color: black !important;\n}\n\n.MuiDialog-container .MuiDialog-paper {\n  background-color: #000;\n  color: #fff;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  padding: 30px 60px 60px 60px;\n  min-width: 700px;\n}\n.MuiDialog-container .MuiDialog-paper .MuiCircularProgress-root {\n  color: var(--color-yellow) !important;\n}\n.MuiDialog-container .MuiDialog-paper .MuiDialogTitle-root .MuiTypography-root {\n  color: #fff;\n  font-size: 38px;\n  font-weight: normal;\n  text-align: center;\n}\n.MuiDialog-container .MuiDialog-paper .MuiDialogContent-root .MuiTypography-root {\n  color: #fff;\n  font-size: 20px;\n  text-align: center;\n  font-weight: 300;\n  margin-bottom: 50px;\n}\n.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root,\n.MuiDialog-container .MuiDialog-paper .MuiDialogContentText-root {\n  justify-content: space-evenly;\n}\n.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root .MuiButtonBase-root,\n.MuiDialog-container .MuiDialog-paper .MuiDialogContentText-root .MuiButtonBase-root {\n  width: 40%;\n}\n.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root .MuiButtonBase-root .MuiButton-label,\n.MuiDialog-container .MuiDialog-paper .MuiDialogContentText-root .MuiButtonBase-root .MuiButton-label {\n  color: yellow;\n}\n.MuiDialog-container .MuiDialog-paper .MuiDialogActions-root .MuiButtonBase-root:hover .MuiButton-label,\n.MuiDialog-container .MuiDialog-paper .MuiDialogContentText-root .MuiButtonBase-root:hover .MuiButton-label {\n  color: #000;\n}\n\n.ReactModal__Overlay--after-open {\n  z-index: 101;\n}\n\n.modal {\n  background-color: black;\n  color: red;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  padding: 45px 65px 65px 65px;\n  text-align: center;\n  width: 90vw;\n  overflow: auto;\n  border: 1px solid #fff;\n  border-radius: 10px;\n  max-height: 100%;\n}\n.modal h2 {\n  font-size: 38px;\n}\n.modal .note-table-wrapper {\n  margin: 20px 0px;\n}\n.modal .close-icon {\n  display: flex;\n  justify-content: flex-end;\n  padding: 0px 10px;\n  cursor: pointer;\n  color: white;\n}\n.modal .find-code-image-wrapper {\n  display: flex;\n  justify-content: center;\n}\n.modal .detail-log-wrapper {\n  display: flex;\n  gap: 10px;\n  margin-top: 20px;\n}\n.modal .detail-log-wrapper .detail-log-info {\n  display: flex;\n  width: 500px;\n  background-color: floralwhite;\n  text-align: left;\n  overflow: auto;\n}\n@media screen and (min-width: 480px) {\n  .modal {\n    width: 450px;\n  }\n}\n@media screen and (min-width: 768px) {\n  .modal {\n    width: 750px;\n    padding: 45px 95px 65px 95px;\n  }\n}\n.modal .bulkCardActionsForms {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 13px 0px;\n  text-align: left;\n}\n.modal .upload-file-container {\n  margin: 17px;\n}\n.modal .upload-file-container .file-upload-btn {\n  color: white;\n  border: 2px solid white;\n  border-radius: 30px;\n  width: 192px;\n  height: 48px;\n  text-transform: unset;\n}\n.modal .upload-file-container .file-upload-btn:hover {\n  color: var(--color-yellow);\n  border: 2px solid var(--color-yellow);\n}\n.modal .upload-file-container .file-upload-btn:hover .MuiSvgIcon-root {\n  color: var(--color-yellow) !important;\n}\n.modal .upload-file-container .file-upload-message {\n  display: flex;\n  align-items: center;\n  margin-left: 10px;\n  color: #fff;\n}\n.modal .cardActionsForms {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin: 13px 0px;\n  text-align: left;\n}\n@media screen and (min-width: 768px) {\n  .modal .cardActionsForms {\n    flex-direction: row;\n  }\n}\n.modal .accordionWrapper {\n  background-color: rgba(0, 0, 0, 0) !important;\n  color: #ffffff !important;\n  margin-top: 30px;\n  max-height: 300px;\n  overflow-y: auto;\n}\n.modal .accordionWrapper .accordionHeading {\n  color: #ffffff !important;\n  font-size: 22px;\n}\n.modal .accordionWrapper .accordionDetails {\n  flex-direction: column;\n  gap: 20px;\n}\n.modal .accordionWrapper .accordionFields {\n  display: flex;\n  gap: 10px;\n}\n.modal .button-container {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin-top: 50px;\n}\n.modal .button-container button {\n  width: 45%;\n}\n.modal .downloadFile {\n  cursor: pointer;\n  color: #fff;\n}\n.modal .field-button-container {\n  display: flex;\n}\n.modal .field-button-container .date-container {\n  width: 100%;\n  text-align: left;\n}\n@media screen and (min-width: 768px) {\n  .modal .field-button-container .date-container {\n    margin-right: 24px;\n  }\n}\n.modal .field-button-container .date-container span {\n  color: white;\n  width: 100px;\n  font-size: 19px;\n}\n.modal .field-button-container .date-container .date-picker-field {\n  background-color: black;\n  border: none;\n  border-bottom: 1px solid white;\n  min-width: 240px;\n  width: 100%;\n  color: white;\n}\n.modal .date-container {\n  text-align: left;\n}\n@media screen and (min-width: 768px) {\n  .modal .date-container {\n    margin-right: 24px;\n  }\n}\n.modal .date-container span {\n  color: white;\n  width: 100px;\n  font-size: 19px;\n}\n.modal .date-container .date-picker-field {\n  background-color: black;\n  border: none;\n  border-bottom: 1px solid white;\n  min-width: 240px;\n  width: 100%;\n  color: white;\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.75);\n}\n\n.card-issued-summary-text {\n  color: white;\n  font-size: 20px;\n  margin: 20px;\n}\n\n.card-cancelled-summary-header {\n  color: white;\n  font-size: 20px;\n  margin: 20px;\n}\n\n.card-cancelled-summary-text {\n  color: white;\n  font-size: 20px;\n  margin: 20px;\n}","/* Box sizing */\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n/* Reset margins */\nbody,\nh1,\nh2,\nh3,\nh4,\nh5,\np {\n  margin: 0;\n  letter-spacing: 0.01em;\n}\n\n/* set up the body */\nbody {\n  line-height: 1.5;\n  min-height: 100vh;\n}\n\n/* make images easier to work with */\nimg {\n  max-width: 100%;\n  display: block;\n}\n\n/* make form elements easier to work with */\ninput,\nbutton,\ntextarea,\nselect {\n  font: inherit;\n}\n\n/* remove animations for people who've turned them off */\n@media (prefers-reduced-motion: reduce) {\n  *,\n  *::before,\n  *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    transition-duration: 0.01ms !important;\n    scroll-behavior: auto !important;\n  }\n}\n",":root {\n  // colors\n  --color-white: #ffffff;\n  --color-black: #000000;\n  --color-grey: #8f8f8f;\n  --color-yellow: #fffb00;\n  --color-red: red;\n\n  // font-size\n\n  --h1-fs: 50px;\n  --h1-lh: 55px;\n\n  --h2-fs: 38px;\n  --h2-lh: 41px;\n\n  --nav-fs: 19px;\n  --nav-lh: 25px;\n\n  --body-fs: 14px;\n  --body-lh: 19px;\n\n  --table-fs: 14px;\n  --table-lh: 16px;\n\n  --subtitle-fs: 14px;\n  --subtitle-lh: 16px;\n\n  // font-weight\n\n  --fw-light: 300;\n  --fw-normal: 400;\n  --fw-medium: 500;\n  --fw-semibold: 600;\n  --fw-bold: 700;\n}\n@media (max-width: 768px) {\n  :root {\n    --h1-fs: 40px;\n    --h1-lh: 45px;\n\n    --h2-fs: 30px;\n    --h2-lh: 35px;\n\n    --nav-fs: 19px;\n    --nav-lh: 25px;\n\n    --body-fs: 16px;\n    --body-lh: 22px;\n\n    --table-fs: 14px;\n    --table-lh: 16px;\n\n    --subtitle-fs: 12px;\n    --subtitle-lh: 16px;\n  }\n}\n\n// mobile : 480px\n// tablet : 768px\n// laptop : 1024px\n// pc up : 1200px","@import './variables';\n\nh1 {\n  font-size: var(--h1-fs);\n  line-height: var(--h1-lh);\n}\n\nh2 {\n  font-size: var(--h2-fs);\n  line-height: var(--h2-lh);\n}\n\nh3 {\n  font-size: var(--body-fs);\n  line-height: var(--body-lh);\n}\nh1,\nh2,\nh3 {\n  font-weight: var(--fw-normal);\n  color: var(--color-white);\n}\np,\na{\n  text-decoration: none;\n  color: var( --color-white );\n  font-weight: var(--fw-normal );\n  font-size: var(--body-fs);\n  line-height: var(--body-lh);\n}\na{\n  transition: all .3s linear;\n  &:hover{\n    color: var(--color-yellow);\n  }\n}","@import './mixins';\n\n.App {\n  background: black;\n  // normal styling code here\n\n  @include respond(tablet) {\n    // responsive code for tablet viewport i.e. 768px\n    button.small {\n      min-height: 148px;\n    }\n  }\n\n  @include respond(mobile) {\n    // responsive code for mobile viewport i.e. 480px\n  }\n}\n","@mixin respond($breakpoint) {\n  // $breakpoint is simply a variable that can have several values\n\n  @if $breakpoint==tablet {\n    // here `laptop` is the value of $breakpoint\n    // when call laptop, we mean the following piece of code\n\n    @media only screen and (max-width: 768px) {\n      @content;\n    }\n  }\n\n  @if $breakpoint==mobile {\n    @media only screen and (max-width: 480px) {\n      @content;\n    }\n  }\n}\n","@import './variables';\n\n.h-full {\n  height: 100vh;\n}\n.w-full {\n  width: 100%;\n}\n.flex {\n  display: flex;\n}\n.flex-col {\n  flex-direction: column;\n}\n.flex-row {\n  flex-direction: row;\n}\n.flex-wrap {\n  flex-wrap: wrap;\n}\n.flex-nowrap {\n  flex-wrap: nowrap;\n}\n.items-center {\n  align-items: center;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n.text-center {\n  text-align: center;\n}\n.bg-black {\n  background-color: var(--color-black);\n}\n.text-white {\n  color: var(--color-white);\n}\n.mx-mobile {\n  margin: 1rem 0;\n}\n.mt-2 {\n  margin-top: 1rem;\n}\n.mt-3 {\n  margin-top: 2rem;\n}\n.mt-4 {\n  margin-top: 3rem;\n}\n.mb-2 {\n  margin-bottom: 1rem !important;\n}\n.mb-3 {\n  margin-bottom: 2rem !important;\n}\n.mb-4 {\n  margin-bottom: 3rem !important;\n}\n.my-max {\n  margin: 5rem 0;\n}\n.min-h-full {\n  min-height: calc(100vh - 63px - 60px);\n  padding-top: 60px !important;\n  @media screen and (min-width: 1200px) {\n    min-height: calc(100vh - 63px );\n    padding-top: 100px !important;\n  }\n}\n.container {\n  padding: 60px 0;\n}\n.w-50{\n  width: 100%;\n  @media screen and (min-width: 1200px) {\n    width: 50%;\n  }\n}\n.no-scroll{\n  overflow : hidden;\n}",".MuiFormControl-root,\n.MuiInputBase-root {\n  width: 100% !important;\n  color: white;\n\n  &.w-50 {\n    @media screen and (min-width: 1200px) {\n      width: 50% !important;\n    }\n  }\n}\n\n.MuiFormHelperText-root {\n  padding-right: 1rem;\n  color: #858585 !important;\n  margin-top: 10px !important;\n  letter-spacing: 0.1px !important;\n}\n\n.MuiInput-underline::before {\n  border-bottom: 1px solid white !important;\n  // border-bottom: 1px solid black !important;\n}\n\n.MuiInput-underline::after {\n  border-bottom: 2px solid white !important;\n  // border-bottom: 2px solid black !important;\n}\n\n.MuiInput-underline.Mui-error::before {\n  border-bottom: 1px solid rgb(255, 83, 83) !important;\n}\n\n.MuiInput-underline.Mui-error::after {\n  border-bottom: 2px solid rgb(255, 83, 83) !important;\n}\n\n.MuiInputBase-input {\n  padding: 4px 0 13px !important;\n  font-size: 19px !important;\n}\n\n.MuiInputLabel-formControl,\n.MuiInputBase-input,\n.MuiSelect-icon,\n.MuiTypography-colorPrimary {\n  top: -10px !important;\n  color: white !important;\n}\n\n.MuiOutlinedInput-notchedOutline {\n  border-color: white !important;\n}\n\n.Mui-error .MuiOutlinedInput-notchedOutline {\n  border-color: rgb(255, 83, 83) !important;\n}\n\n.MuiButton-root {\n  line-height: 1.1 !important;\n}\n\n.MuiButton-root:hover .MuiSvgIcon-root {\n  color: black !important;\n}\n\n.MuiButton-root:hover .MuiCircularProgress-root {\n  color: black !important;\n}\n\n.MuiContainer-root {\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n}\n\n#email-helper-text,\n#password-helper-text {\n  color: rgb(248, 132, 132) !important;\n  margin: 0;\n}\n\ntable {\n  background: #000000;\n}\n\n.MuiTableCell-body,\n.MuiTableCell-head {\n  color: white !important;\n}\n\n.apexcharts-text tspan {\n  color: white;\n  font-size: 16px;\n}\n\n/* Chrome, Safari, Edge, Opera */\ninput::-webkit-outer-spin-button,\ninput::-webkit-inner-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* Firefox */\ninput[type='number'] {\n  -moz-appearance: textfield;\n}\n\ninput[aria-invalid='true'] {}\n\n.mui-checkbox {\n  .MuiIconButton-colorPrimary {\n    color: #fff !important;\n  }\n\n  .MuiFormControlLabel-label {\n    color: #fff !important;\n  }\n}\n\n.MuiInputBase-input:-internal-autofill-selected {\n  background: black !important;\n}\n\n.MuiInputBase-input:-webkit-autofill,\n.MuiInputBase-input:-webkit-autofill:hover,\n.MuiInputBase-input:-webkit-autofill:focus,\n.MuiInputBase-input:-webkit-autofill:active {\n  -webkit-box-shadow: 0 0 0 30px black inset !important;\n  -webkit-text-fill-color: white !important;\n}\n\n.MuiTableContainer-root {\n  // &::-webkit-scrollbar{\n  //   display: none;\n  // }\n  // -ms-overflow-style: none;\n  // scrollbar-width: none;\n}\n\n.MuiSelect-selectMenu {\n  padding: 4px 24px 13px 0 !important;\n}\n\nbutton.react-datepicker__close-icon {\n  border: 0 !important;\n\n  &::after {\n    font-size: 25px;\n    font-weight: 1000;\n    background-color: transparent !important;\n  }\n\n  &:hover {\n    background-color: transparent !important;\n\n    &::after {\n      color: var(--color-yellow) !important;\n    }\n  }\n}\n\nbutton.react-datepicker__navigation.react-datepicker__navigation--next {\n  border: none !important;\n}\n\nbutton.react-datepicker__navigation.react-datepicker__navigation--next {\n  border: none !important;\n\n  .react-datepicker__navigation-icon.react-datepicker__navigation-icon--next {\n    width: 0 !important;\n\n    &:before {\n      border-color: black !important;\n      margin-top: 5px\n    }\n  }\n\n  &:hover {\n    background-color: transparent !important;\n  }\n}\n\nbutton.react-datepicker__navigation.react-datepicker__navigation--previous {\n  border: none !important;\n\n  .react-datepicker__navigation-icon.react-datepicker__navigation-icon--previous {\n    width: 0 !important;\n\n    &:before {\n      border-color: black !important;\n      margin-top: 5px\n    }\n  }\n\n  &:hover {\n    background-color: transparent !important;\n  }\n}\n\n.MuiFormLabel-root {\n  font-size: 19px !important;\n}\n\n.MuiButton-label {\n  font-size: 16px;\n\n  @media (min-width: 720px) {\n    font-size: 19px;\n  }\n}\n\n.MuiAlert-action {\n  button {\n    color: red !important;\n    border: 1px solid red !important;\n    height: 20px;\n    width: 20px;\n\n    &:hover {\n      color: red !important;\n      border: 1px solid red !important;\n      background-color: transparent !important;\n      transform: scale(1.1);\n    }\n  }\n}\n\n.error-table-container {\n  table {\n\n    // background: #c52525 !important;\n    thead,\n    tbody,\n    tfooter {\n      tr {\n\n        td,\n        th {\n          border-color: red !important;\n        }\n      }\n    }\n\n    tbody {\n      tr {\n\n        td,\n        th {\n          color: red !important;\n        }\n      }\n    }\n  }\n}\n\n.MuiTableCell-root p {\n  font-size: 0.875rem;\n}\n\n.MuiAlert-message {\n  width: 400px;\n}\n\n.MuiTablePagination-root {\n  color: white !important;\n  background-color: black !important;\n  .MuiTypography-colorInherit {\n    color: white !important;\n  }\n  .MuiTablePagination-input {\n    width: 200px !important;\n  }\n}\n","\n* {\n  font-family: \"Haas Grot Disp R Web\";\n  // color: var(--color-white);\n}\nbody {\n  background-color: var(--color-black);\n}\nbutton.w-100 {\n  width: 100% !important;\n}\n\n.secondary-font {\n  font-family: \"Neuzeit S LT Std\", \"Sans-serif\";\n}\n\n.suncorp-font {\n  font-family: \"Atlas Grotesk\", \"Arial\", \"sans-serif\";\n}\n\n.aami-font {\n  font-family: \"Futura\", \"Arial\", \"sans-serif\";\n}\n\n.apia-font {\n  font-family: \"Neue Haas Grotesk\";\n}\n",".site-header{\n    background: var(--color-black);\n    color: var(--color-white);\n    height: 60px;\n    @media screen and (min-width: 1200px) {\n        height: 100px;\n        width: 100%;\n        position: absolute;\n        top: 0;\n        background: transparent;\n        z-index: 100;\n    }\n    .navigation-container{\n        width: 100%;\n        padding: 16px 18px 0;\n        // position: fixed;\n        top: 0;\n        z-index: 1;\n        background: var(--color-black);\n        font-family: 'Haas Grot Disp';\n        height: 60px;\n        @media screen and (min-width: 1200px) {\n            height: 100px;\n            padding: 20px 25px;\n            background: transparent;\n        }\n        &.scroll{\n            padding: 20px 25px 0;\n            position: fixed;\n            background: black;\n        }\n        .navbar{\n            display: flex;\n            flex-wrap: wrap;\n            align-items: center;\n            justify-content: space-between;\n            .navbar-logo {\n                width: 100px;\n            }\n            .site-header-navigation{\n                ul.primary-menu{\n                    display: flex;\n                    flex-direction: column;\n                    background: #222222;\n                    width: 100%;\n                    height: 100%;\n                    flex-wrap: wrap;\n                    top: -150%;\n                    left: 0;\n                    position: fixed;\n                    opacity: 1;\n                    transition: all 0.5s ease;\n                    @media screen and (min-width: 1200px) {\n                        position: unset;\n                        height: auto;\n                        width: auto;\n                        align-items: center;\n                        flex-direction: row;\n                        justify-content: center;\n                        padding: 15px 29px 19px;\n                        margin: 0;\n                        border-radius: 11px;\n                        box-shadow: 0 9px 20px #222;\n                    }\n                    &.active{\n                        padding: 10px 16px 10px 16px;\n                        margin-top: 0;\n                        top: 57px;\n                        z-index: 1;\n                        transition: all 0.5s ease;\n                        background-color: var(--color-black);\n                        li{\n                            margin: 13px 0 0 0;\n                            a{\n                                width: 100%;\n                                display: flex;\n                                justify-content: space-between;\n                                .navigation-more{\n                                    display: block;\n                                }\n                            }\n                            &.main-navigation-search{\n                                display: none;\n                            }\n                        }\n                    }\n                    li{\n                        list-style: none;\n                        margin-right: 57px;\n                        &:nth-last-child(1){\n                            margin-right: 0;\n                        }\n                        a{\n                            font-size: 19px;\n                            line-height: 26px;\n                            &:hover{\n                                color: var(--color-yellow)\n                            }\n                            display: flex;\n                            .navigation-more{\n                                display: none;\n                            }\n                            &.active{\n                                color: var(--color-yellow);\n                            }\n                        }\n                    }\n                }\n            }\n            .site-header-profile{\n                display: flex;\n                align-items: center;\n                justify-content: center;\n                position: relative;\n                .dots-icon-holder{\n                    .navigation-dots{\n                        cursor : pointer;\n                        margin-left: 19px;\n                    }\n                    @media screen and (min-width: 1200px) {\n                        display: none;\n                    }\n                }\n                .search-icon-holder{\n                    .navigation-search{\n                        cursor : pointer;\n                        margin-right: 19px;\n                    }\n                    @media screen and (min-width: 1200px) {\n                        display: none;\n                    }\n                }\n                .profile-icon-holder{\n                    .dropdown-icon{\n                        margin-left: -3px;\n                        @media screen and (min-width : 1200px ){\n                            margin-left: 0;\n                        }\n                    }\n                }\n                .menu-dropdown-holder{\n                    z-index: 10;\n                    top: 25px !important;\n                    left: unset !important;\n                    right: 0;\n                    transform: unset !important;\n                    .MuiPaper-rounded{\n                        border-radius: 20px!important;\n                    }\n                    .sub-menu-list{\n                        li{\n                            padding: 16px;\n                            background-color: transparent;\n                            &:hover{\n                                background-color: transparent;\n                            }\n                            p{\n                                color: var(--color-black);\n                            }\n                            &.logout-item{\n                                display: flex;\n                                justify-content: center;\n                                transition: all 0.3s linear;\n                                background-color: #222;\n                                border-radius: 50px;\n                                margin:8px;\n                                span{\n                                    color: var(--color-yellow);\n                                    width: 100%;\n                                    text-align: center;\n                                        // color:var(--color-black);\n                                }\n                                &:hover{\n                                    background-color: #8F8F8F;\n                                    span{\n                                        color: var(--color-yellow)\n                                    }\n                                }\n                            }\n                        }\n                    }\n                }\n            }\n        }\n    }\n}","@import '../variables';\n\nbutton {\n  background: transparent !important;\n  color: var(--color-yellow) !important;\n  text-transform: capitalize !important;\n  border: 1px solid var(--color-yellow) !important;\n  border-radius: 30px !important;\n  height: 48px;\n  padding: 1rem 0.5rem;\n  font-size: var(--body-fs);\n  font-weight: var(--fw-medium);\n\n  .MuiButton-label {\n    font-size: 18px;\n  }\n\n  &:hover {\n    background: var(--color-yellow) !important;\n    color: var(--color-black) !important;\n  }\n\n  &.large {\n    min-width: 336px;\n  }\n\n  &.small {\n    min-width: 192px;\n  }\n\n  &.deactivate-btn {\n    color: var(--color-red) !important;\n    border: 2px solid var(--color-red) !important;\n    margin-top: 5px;\n\n    &:hover {\n      background: var(--color-red) !important;\n      color: var(--color-black) !important;\n    }\n\n    .MuiButton-label {\n      font-size: var(--table-fs);\n    }\n  }\n\n  &.resend-email-btn {\n    margin-top: 5px;\n\n    .MuiButton-label {\n      font-size: var(--table-fs);\n    }\n  }\n}","footer.site-footer{\n    background: var(--color-black);\n    border-top: 0.5px solid #fff;\n    padding: 17px 25px 19px;\n    p{\n        font-size: 19px;\n        font-family: 'Haas Grot Disp';\n        line-height: 25px;\n    }\n}",".dialog-action-btn {\n    color: black !important;\n}\n\n\n.MuiDialog-container .MuiDialog-paper {\n    background-color: #000;\n    color: #fff;\n    border: 1px solid #fff;\n    border-radius: 10px;\n    padding: 30px 60px 60px 60px;\n    min-width: 700px;\n\n    .MuiCircularProgress-root {\n        color: var(--color-yellow) !important;\n    }\n\n    .MuiDialogTitle-root .MuiTypography-root {\n        color: #fff;\n        font-size: 38px;\n        font-weight: normal;\n        text-align: center;\n    }\n\n    .MuiDialogContent-root .MuiTypography-root {\n        color: #fff;\n        font-size: 20px;\n        text-align: center;\n        font-weight: 300;\n        margin-bottom: 50px;\n    }\n\n    .MuiDialogActions-root,\n    .MuiDialogContentText-root {\n        justify-content: space-evenly;\n\n        .MuiButtonBase-root {\n            width: 40%;\n\n            .MuiButton-label {\n                color: yellow;\n            }\n\n            &:hover .MuiButton-label {\n                color: #000;\n            }\n        }\n    }\n}\n",".ReactModal__Overlay--after-open {\n    z-index: 101;\n    // background-color: rgba(255, 255, 255, 0.1) !important;\n    // background-color: rgba(85, 76, 76, 0.253) !important;\n    // background-color: red !important;\n    // background-color: unset !important;\n}\n\n.modal {\n    background-color: black;\n    color: red;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    padding: 45px 65px 65px 65px;\n    text-align: center;\n    width: 90vw;\n    overflow: auto;\n    border: 1px solid #fff;\n    border-radius: 10px;\n    max-height: 100%;\n\n    h2 {\n        font-size: 38px;\n    }\n\n    .note-table-wrapper {\n        margin: 20px 0px;\n    }\n\n    .close-icon {\n        display: flex;\n        justify-content: flex-end;\n        padding: 0px 10px;\n        cursor: pointer;\n        color: white;\n    }\n\n    .find-code-image-wrapper {\n        display: flex;\n        justify-content: center;\n    }\n\n    .detail-log-wrapper {\n        display: flex;\n        gap: 10px;\n        margin-top: 20px;\n\n        .detail-log-info {\n            display: flex;\n            width: 500px;\n            background-color: floralwhite;\n            text-align: left;\n            overflow: auto;\n        }\n    }\n    // border-radius: 5%;\n    @media screen and (min-width: 480px) {\n        // border-radius: 10%;\n        width: 450px;\n    }\n\n    @media screen and (min-width: 768px) {\n        width: 750px;\n        padding: 45px 95px 65px 95px;\n    }\n\n    .bulkCardActionsForms {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        margin: 13px 0px;\n        text-align: left;\n    }\n\n    .upload-file-container {\n        margin: 17px;\n\n        .file-upload-btn {\n            color: white;\n            border: 2px solid white;\n            border-radius: 30px;\n            width: 192px;\n            height: 48px;\n            text-transform: unset;\n\n            &:hover {\n                color: var(--color-yellow);\n                border: 2px solid var(--color-yellow);\n\n                .MuiSvgIcon-root {\n                    color: var(--color-yellow) !important;\n                }\n            }\n        }\n\n        .file-upload-message {\n            display: flex;\n            align-items: center;\n            margin-left: 10px;\n            color: #fff;\n        }\n    }\n\n    .cardActionsForms {\n        display: flex;\n        flex-direction: column;\n        gap: 10px;\n        margin: 13px 0px;\n        text-align: left;\n\n        @media screen and (min-width: 768px) {\n            flex-direction: row;\n        }\n    }\n\n    .accordionWrapper {\n        background-color: rgba(0, 0, 0, 0) !important;\n        color: #ffffff !important;\n        margin-top: 30px;\n        max-height: 300px;\n        overflow-y: auto;\n\n        .accordionHeading {\n            color: #ffffff !important;\n            font-size: 22px;\n        }\n\n        .accordionDetails {\n            flex-direction: column;\n            gap: 20px\n        }\n\n        .accordionFields {\n            display: flex;\n            gap: 10px;\n        }\n    }\n\n    .button-container {\n        display: flex;\n        flex-wrap: wrap;\n        justify-content: space-between;\n        margin-top: 50px;\n\n        button {\n            width: 45%;\n        }\n    }\n\n    .downloadFile {\n        cursor: pointer;\n        color: #fff;\n    }\n\n    .field-button-container {\n        display: flex;\n\n        .date-container {\n            width: 100%;\n            text-align: left;\n\n            @media screen and (min-width: 768px) {\n                // width: calc( 50% - 24px );\n                margin-right: 24px;\n            }\n\n            span {\n                color: white;\n                width: 100px;\n                font-size: 19px;\n            }\n\n            .date-picker-field {\n                background-color: black;\n                border: none;\n                border-bottom: 1px solid white;\n                min-width: 240px;\n                width: 100%;\n                color: white;\n            }\n        }\n    }\n\n    .date-container {\n        // width: 100%;\n        text-align: left;\n\n        @media screen and (min-width: 768px) {\n            // width: calc( 50% - 24px );\n            margin-right: 24px;\n        }\n\n        span {\n            color: white;\n            width: 100px;\n            font-size: 19px;\n        }\n\n        .date-picker-field {\n            background-color: black;\n            border: none;\n            border-bottom: 1px solid white;\n            min-width: 240px;\n            width: 100%;\n            color: white;\n        }\n    }\n}\n\n.overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background-color: rgba(0, 0, 0, 0.75);\n}\n\n.card-issued-summary-text {\n    color: white;\n    font-size: 20px;\n    margin: 20px;\n}\n\n.card-cancelled-summary-header {\n    color: white;\n    font-size: 20px;\n    margin: 20px;\n}\n\n.card-cancelled-summary-text {\n    color: white;\n    font-size: 20px;\n    margin: 20px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
